var currentSearch = '';
var slideStore = 0;
var picker_desktop = '';
var home_picker_desktop = '';
const menuItems = document.querySelectorAll('.nav-link-dropdown > a');
let activeDropdown = null;
let isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
// Mobile filter panel: filter changes made while the panel is open are applied on "Apply" (or when the
// panel closes), not on every tap. Desktop filters still reload immediately.
let tmFiltersPendingReload = false;
function tmFiltersPanelOpen() { return document.documentElement.classList.contains('filtersOpen'); }
function tmFiltersApplyPending() {
	if ( tmFiltersPendingReload ){
		tmFiltersPendingReload = false;
		ajaxReload();
	}
}
var searchLinkFlag = false;
var selectedSearchLink = '';
var isReviewSliding = false;

// Initialize the back-to-top functionality
document.addEventListener("DOMContentLoaded", () => {
	const hasBackToTopElement = document.querySelectorAll('.m-backtotop').length > 0;

	if ( hasBackToTopElement ){
    	new BackToTop(".m-backtotop");
	}
});

// Function to handle scroll event
let lastValidSection = "";

window.addEventListener("scroll", () => {
  const sections = document.querySelectorAll("div[data-automation]");
  const navItems = document.querySelectorAll("div[role='button']");

  if (sections.length > 0) {
    let currentSection = lastValidSection;
    const viewportHeight = window.innerHeight;

    sections.forEach((section, index) => {
      const rect = section.getBoundingClientRect();

      if (rect.top <= 150 && rect.bottom >= 150) {
        currentSection = section.getAttribute("data-automation");
      }

      if (index === 0 && rect.top > 150) {
        currentSection = sections[0].getAttribute("data-automation");
      }
      if (index === sections.length - 1 && rect.bottom < viewportHeight) {
        currentSection = sections[sections.length - 1].getAttribute("data-automation");
      }
    });

    if (currentSection) {
      lastValidSection = currentSection; // Update only if valid section is found
    }

    navItems.forEach((item) => {
      const itemId = item.id;
      if (itemId === lastValidSection) {
        item.setAttribute("aria-pressed", "true");
        item.scrollIntoView({ behavior: "instant", block: "nearest", inline: "center" });
      } else {
        item.setAttribute("aria-pressed", "false");
      }
    });
  }
});



document.addEventListener("DOMContentLoaded", function () {
    const stickyHeader = document.querySelector(".stickyHeaderWrapper");
    const stickyFooter = document.querySelector(".wishlistAndFooterWrapper");
    const chatBot = document.querySelector(".c-chat-bot");
	const chatBotWidget = document.querySelector("#c-help-center");

	let activityRight = document.querySelector(".activity-right");

	if ( document.querySelector("#s-page-container") !== null ){

		activitySelector = window.innerWidth < 1025 ? ".widget-mobile-wrapper" : ".media-gallery";
		activityRight = document.querySelector(activitySelector);
	}

    if ( stickyHeader !== null ){
	    function checkVisibility() {
	        if (!activityRight || !stickyHeader) return;

	        const activityBottom = activityRight.getBoundingClientRect().bottom; // Get bottom position relative to viewport
	        const windowScrollY = window.scrollY || document.documentElement.scrollTop;

	        // Check if the bottom of .activity-right reaches the bottom of the viewport
	        if ( activityBottom < 0 ) {
	            stickyHeader.classList.add("visible");

				if ( document.querySelector("#s-page-container") === null ){
					if ( stickyFooter ){
						stickyFooter.classList.add("visible");

						if ( chatBot ){
							chatBot.classList.add("c-chat-bot-margin");

							if ( chatBotWidget ){
								chatBotWidget.classList.add("c-chat-bot-margin");
							}
						}
					}
				}
	        } else {
	            stickyHeader.classList.remove("visible");

				if ( document.querySelector("#s-page-container") === null ){
					if ( stickyFooter ){
						stickyFooter.classList.remove("visible");

						if ( chatBot ){
							chatBot.classList.remove("c-chat-bot-margin");

							if ( chatBotWidget ){
								chatBotWidget.classList.remove("c-chat-bot-margin");
							}
						}
					}
				}
	        }
	    }

	    function checkVisibilityFooter() {

			elementPositionFooterVisibility = window.innerWidth < 1025 ? document.querySelector(".widget-mobile-wrapper").getBoundingClientRect().bottom : document.querySelector("#s-page-container").getBoundingClientRect().top;

			if ( stickyFooter ){
				if ( elementPositionFooterVisibility > 0 ) {
					stickyFooter.classList.remove("visible");
					if ( chatBot ){
						chatBot.classList.remove("c-chat-bot-margin");
						chatBot.classList.add("c-desktop-only");

						if ( chatBotWidget ){
							chatBotWidget.classList.remove("c-chat-bot-margin");
						}
					}
				} else {
					stickyFooter.classList.add("visible");
					if ( chatBot ){
						chatBot.classList.add("c-chat-bot-margin");
						chatBot.classList.remove("c-desktop-only");

						if ( chatBotWidget ){
							chatBotWidget.classList.add("c-chat-bot-margin");
						}
					}
				}
			}
	    }

	    window.addEventListener("scroll", checkVisibility);
	    checkVisibility(); // Initial check on page load

		if ( document.querySelector("#s-page-container") !== null ){
			window.addEventListener("scroll", checkVisibilityFooter);
			checkVisibilityFooter(); // Initial check on page load
		}
	  }
});



function fixWidth(){
	$(".categories-outer").css( "max-width", $(".categories-outer").closest(".shellContainer").width() ); // the panel's full width: common.css .categories-outer pins it at left 0 with its gutter inside (COOL 374)
}

function linkClick( obj ){

	if ( jQuery(obj.target).parents('.favorite-icon').length || jQuery(obj.target).is('.favorite-icon') ){
		return;
	}

	if(jQuery(obj.target)[0].tagName.toLowerCase() === 'a')
	{
		obj.stopPropagation();
		return;
	}

	if ( jQuery(obj.currentTarget).find(".product-card.no-link").length === 1 ){
		obj.preventDefault();
		return false;
	}

	var links = jQuery(obj.currentTarget).find("a");
	var selectedLink = null;

	links.each(function(index, element) {
		if(element.href.match(/\/activity\//)) {
			selectedLink = element;
			return false;
		}
	});

	if( !selectedLink && (links.length > 0) ) {
		selectedLink = links[0];
	}


	if(selectedLink) {
		var target = jQuery(selectedLink).attr('target');

		if(target && target.trim() === '_blank') {
			window.open( jQuery(selectedLink).attr("href"), '_blank');
		} else {
			window.location = jQuery(selectedLink).attr("href");
		}

		obj.preventDefault();
		return false;
	}
}

function initReadMoreStops(containerSelector, lineClamp = 4) {
  $(containerSelector).each(function () {
    const content = $(this);
    const button = $(this).next(".read-more-link-with-icon");

    const checkLines = () => {
      const lineHeight = parseFloat(content.css("line-height"));
      const height = content.outerHeight();
      return Math.floor(height / lineHeight);
    };

    if ( checkLines() > lineClamp ) {
      content.addClass("read-more-content-enable");
      button.show(); // Show button if needed
    } else {
      content.removeClass("read-more-content-enable");
      button.hide(); // Hide button if not needed
    }

    // Toggle functionality
    button.on("click", function (e) {
      e.preventDefault();
      content.toggleClass("expanded");
      $(this).html(content.hasClass("expanded") ? "<span>Read less</span> <i class='far fa-chevron-up fa-xs' aria-hidden='true'></i>" : "<span>Read more</span> <i class='far fa-chevron-down fa-xs' aria-hidden='true'></i>");
    });
  });

 $(containerSelector).parents('.what-to-expect-content').find(".itineraryStop:gt(1)").addClass("hidden");
 $(containerSelector).parents('.what-to-expect-content').find(".itineraryStop:lt(2)").addClass("always-visible-item");
}

if ( document.querySelectorAll(".slick-slider-banner").length > 0 ){
	if ( isMobileDevice ){
		$(".home #full-width-slider .slider-type-search_transparent > div:not(:first-child), .home #full-width-slider .slider-type-search > div:not(:first-child)").remove();
	}

	if ( typeof slick_slider_banner_arg === 'undefined' ){
		slick_slider_banner_arg = {
			arrows: true,
			dots: false,
			speed: 400,
			touchThreshold: 15,
			lazyLoad: 'ondemand',
		}
	}

	// every banner / gallery slider gets the one circle arrow (components/button c-btn-circle — Peter, 2026-09-18)
	slick_slider_banner_arg.prevArrow = '<button type="button" class="slick-prev c-btn c-btn-circle c-btn-shadow c-btn-on-image" aria-label="Previous"><i aria-hidden="true" class="fa-regular fa-chevron-left"></i></button>';
	slick_slider_banner_arg.nextArrow = '<button type="button" class="slick-next c-btn c-btn-circle c-btn-shadow c-btn-on-image" aria-label="Next"><i aria-hidden="true" class="fa-regular fa-chevron-right"></i></button>';
	// product photo gallery (components/slider.php): pill dots on the picture — phones have no arrows or thumbnails, so
	// the dots are the only sign there is more to swipe (Peter, 2026-09-21); components/slider.scss hides them on desktop
	// skip a slider that is already slick-initialized (e.g. markup served with slick's DOM in it): slick's initADA then
	// throws on a null $slides, and that throw stops the rest of footer-app-bundle (Modal, TabNavigation never defined)
	$(".slick-slider-banner.media-gallery-slider:not(.slick-initialized)").slick(Object.assign({}, slick_slider_banner_arg, { dots: true }));
	$(".slick-slider-banner:not(.media-gallery-slider):not(.slick-initialized)").slick(slick_slider_banner_arg);
}

function openNavDropdown(e) {
	$(e).addClass("active");
		$(e).find(".section-nav-dropdown").addClass("nav-open")
		$(e).find(".main-navigation-link__mobile-toggle").addClass("main-navigation-link__mobile-toggle--close");
}

function refreshSliders( windowObj ){
	//if ( $(windowObj).width() > 504 && $(".scroll-slider .slick-track").length == 0 ){
		if ( $('.scroll-slider.row-1:not(.slick-initialized)').length > 0
			|| $(".wish-list-carousel").length > 0
			|| $("body.page-template-template-home-portal-new, body.page-template-template-destinations-home").length > 0
			|| $(".unsubscribe-page-content").length > 0
		) {
			loadSliders();
		}
	//}
}

function loadSliders(){

	var $slider = $('.scroll-slider:not(.recently-viewed-slider).row-1:not(.slick-initialized)');

	$slider.on("init.slick", function(){
		$(".scroll-slider.row-1 .static-item").off().on("click",linkClick);
	})

	$slider.on("swipe", function(){
		$(".scroll-slider.row-1 .static-item").off("click",linkClick);
	})

	$slider.on("afterChange", function(){
		$(".scroll-slider.row-1 .static-item").off().on("click",linkClick);
	})

	let slider_options = {
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true,
				touchThreshold: 20,
				prevArrow: '<button type="button" class="slick-prev c-btn c-btn-circle c-btn-shadow" aria-label="Previous"><i aria-hidden="true" class="fa-regular fa-chevron-left"></i></button>',
				nextArrow: '<button type="button" class="slick-next c-btn c-btn-circle c-btn-shadow" aria-label="Next"><i aria-hidden="true" class="fa-regular fa-chevron-right"></i></button>',
				responsive: [
						{
								breakpoint: 950,
								settings: {
										slidesToShow: 3,
										slidesToScroll: 3,
								}
						},
						{
								breakpoint: 600,
								settings: {
										slidesToShow: 2,
										slidesToScroll: 2,
								}
						},
						{
								breakpoint: 505,
								settings: "unslick"
						},
				]
	};

	if ( $("body.home").length == 1 ){
		slider_options.infinite = true;
		slider_options.slidesToScroll = 4;
	}

	$slider.slick( slider_options );

	if ( $slider.parents(".recentReviews").length > 0 ){
		let slidesToShow = 4;
		let slidesToScroll = 4;
		$slider = $(".recentReviews .scroll-slider");

		$slider.on("swipe", function() {
    		isReviewSliding = true;

    		setTimeout(function() {
        		isReviewSliding = false;
    		}, 100);
		});

		$slider.slick('slickSetOption', 'slidesToShow', slidesToShow, true);
		$slider.slick('slickSetOption', 'slidesToScroll', slidesToScroll, true);
	}

	if ( $(".scroll-slider.no-loop").length > 0 ){
		$(".scroll-slider.no-loop").each( function(){
			$(this).slick('slickSetOption', 'infinite', false, true);
		});
	}

	var $slider2 = $('.scroll-slider.rows-2:not(.slick-initialized)');


	if ($(window).width() < 900) {
		mobileGridSlickSlider( $slider2 );
	}else{
		desktopGridSlickSlider( $slider2 );
	}

}

function restartSearch(){
	search_keyword = '';
	if ( help_center_search_ajax !== null ){
		help_center_search_ajax.abort();
	}
	$("#_tm_io_placebo").val('');
	$("._tm_search_results").hide();
	$("._tm_close_search_icon_container").hide();
	$(".search_results_loader").hide();
}

function showContactLinks(){
	$(".top-bar-nav").addClass("loaded");
}


/*function showCallBackRequest(){
		if ( isSaleDepartment() ){
			if ( document.querySelector(".contact_info .help-center-link") !== null ){
				document.querySelector(".top-bar-nav li.contact_info").removeChild( document.querySelector(".top-bar-nav li.contact_info").children[0] );
				document.querySelector(".top-bar-nav li.contact_info").innerHTML = `<a href="#" class="help-center-link" data-help-center="talk-us"><span class="fal fa-phone-alt icon"></span> <span class="underline-hover">Call Us</a></span>`;
			}
		}
}*/

/*function showCallNumber( fullN = false ){
	if ( tmVisitorStore.isSalesDepartment() && typeof lm !== 'undefined' ){
		if ( document.querySelector(".contact_info .help-center-link") !== null ){
			var f = fullN ? lm : 'Call Us';
			try {
				document.querySelector(".top-bar-nav li.contact_info").removeChild( document.querySelector(".top-bar-nav li.contact_info").children[0] );
				document.querySelector(".top-bar-nav li.contact_info").innerHTML = `<a href="tel:${lm}"><span class="fal fa-phone-alt icon"></span> <span class="underline-hover">${f}</a></span>`;

				document.querySelector(".call_page a[data-help-center=talk-us]").className = document.querySelector(".call_page a[data-help-center=talk-us]").classList.value.replace("help-center-link","");
				document.querySelector(".call_page a[data-help-center=talk-us]").setAttribute("href",  document.querySelector(".top-bar-nav li.contact_info a").getAttribute("href") );
			} catch (e) {}
		}
	}
}*/

function getQueryStringValueFromCurrentUrl(key) {
	return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

function loadActivityThumbsSliders() {
	if ( $(".dynamic-filters-display").is(":visible") ){

		$('.dynamic-filters-display').each(function(){

			var sliderContainer = $(this);
			var orionSlider = $(this).find(".orion-slider");
			var nextArrowElement = sliderContainer.find('.next-arrow');
			var prevArrowElement = sliderContainer.find('.prev-arrow');

			orionSlider.slick({
				accessibility: false,
				arrows: true,
				infinite: false,
				lazyLoad: "none",
				slidesToShow: 5,
				slidesToScroll: 5,
				swipeToSlide: false,
				speed: 400,
				touchThreshold: 15,
				variableWidth: true,
				nextArrow: nextArrowElement,
				prevArrow: prevArrowElement,
				responsive : [
					{
						breakpoint: 993,
						settings: "unslick"
					}
				]
			});

		})

		updateActivityTypeChips(); // chips the page rendered hidden (no tours on the visitor's dates) leave the slider too
	}
}

// The type chips under the title: a type with no tours on the visitor's dates is hidden, this page's own type never
// (Peter, COOL 277; dates only, COOL 479). counts = a reload's types with tours (load_activities, from
// getTmActivityTypeCountsForDestinationSlug: type id => 1), empty = no dates or no tours at all, so every chip shows
// again; none = keep the hidden attributes the page came with. The desktop row is a slick slider: a hidden chip's slide
// is filtered out of it.
function updateActivityTypeChips(counts) {
	$('.dynamic-filters-display .orion-slider').each(function() {
		var $slider = $(this);
		var isSlider = $slider.hasClass('slick-initialized');

		if (!$slider.data('typeChipsWatched')) {
			$slider.data('typeChipsWatched', true);
			$slider.data('allChips', $slider.find('.dynamic-filter')); // every chip, in the page's order (COOL 479)
			// slick's unslick (narrower than 993px, its debounced resize) keeps only the slides it shows: put the filtered-out
			// chips back first (still hidden) so a later reload can show them, and filter again when it is a slider again.
			// window.innerWidth: the width slick checks its breakpoint against (COOL 479)
			$(window).on('resize', function() {
				if ($slider.hasClass('slick-initialized') && window.innerWidth < 993) {
					$slider.slick('slickUnfilter');
				}
			});
			$slider.on('init', function() {
				setTimeout(function() { updateActivityTypeChips(); }); // after slick finishes setting itself up
			});
		}

		if (isSlider) {
			$slider.slick('slickUnfilter');
		}
		else {
			// an unslick the resize above did not see first (slick's own orientationchange) dropped the filtered-out chips:
			// put them all back in the page's order, still hidden, without the aria-hidden slick's filter left on them (COOL 479)
			var $allChips = $slider.data('allChips');
			if ($allChips.filter(function() { return !$.contains($slider[0], this); }).length) {
				$slider.append($allChips.removeAttr('aria-hidden data-slick-index'));
			}
		}

		if (counts !== undefined) {
			var showAll = !counts || $.isEmptyObject(counts);
			$slider.find('.dynamic-filter').each(function() {
				var typeId = $(this).data('typeId');
				var hasTours = showAll || !typeId || $(this).hasClass('selected-filter') || (counts[typeId] || 0) > 0;
				$(this).prop('hidden', !hasTours);
			});
		}

		if (isSlider && $slider.find('.dynamic-filter[hidden]').length) {
			$slider.slick('slickFilter', function(index, slide) {
				return !$(slide).is('.dynamic-filter[hidden]') && !$(slide).find('.dynamic-filter[hidden]').length;
			});
		}
	});
}

function actionsBasedOnSupportTime() {

	/*let isCallUsTimeValid = tmUtils.isTmSupportOnline();
	if ( typeof mm !== 'undefined' && mm > 100 && isCallUsTimeValid && typeof currentBlogWebsiteType !== "undefined" && currentBlogWebsiteType !== 'portal' ){
		showCallNumber( true );
	}
	if ( typeof Cookies === 'function' ){
		if ( Cookies.get("set-call-number") !== 'undefined' && Cookies.get("set-call-number") === 'true' && isCallUsTimeValid && typeof currentBlogWebsiteType !== "undefined" && currentBlogWebsiteType !== 'portal'){
			showCallNumber( true );
		}
	}*/

	showContactLinks();
}
function initStickyHeaders() {
	$(".stickyHeaderWrapper .wrapper").empty();

	$(".right-section [data-automation]").each( function( index ){
		automationID = $(this).data("automation");
		automationTitle = $("[data-automation=" + automationID + "] h2")[0].innerText;
		ariaPressed = index > 1 ? false : true;
		$(".stickyHeaderWrapper .wrapper").append(`
			<div id="${automationID}" role="button" tabindex="0" aria-pressed="${ariaPressed}" aria-disabled="false">
				<span class="tabWrapper" title="${automationTitle}">${automationTitle}</span>
			</div>
			`)
	});

	//$(".stickyHeaderWrapper .wrapper > div:eq(0)").attr("aria-pressed", true);
	$(".stickyHeaderWrapper .wrapper > div").on("click", function(e){
		e.preventDefault();
		automationID = $(this).attr("id");
		clickedSection = $("[data-automation=" + automationID + "]");

    $('html, body').animate({
        	scrollTop: (clickedSection.offset().top - 60)
    	}, 0);
	})
}

jQuery(document).ready(function($) {

	// first: the ticket page's styles show only the first check-in code until slick runs, so this never waits on the rest
	// of this handler (an error further down would leave the other codes unreachable)
	initTicketCodesSlickSlider();

	if ( $(".filter-container-top .activity-filter").length ){
		$(".filter-container-top .activity-filter").show();
		if ( isMobileDevice ){
			$(".filter-container-top .activity-filter").addClass("activity-filter-mobile-loaded");
			$(".filter-container-top #modern-date-placeholder").text("Dates"); // as the markup says it at phone width (filter-top.php)

            if ( $("body.id-7").length && $(".c-search-date-text:visible").length ){
                $(".activity-filter.activity-filter-mobile-loaded").addClass("c-desktop-only");
            }
		}else{
			$(".filter-container-top .activity-filter").addClass("activity-filter-desktop-loaded");
		}
	}

	$(window).on('scroll', function () {
		if ( $('.filter-container-top').length ){
			//$('.filter-container-top').toggleClass('c-filter-is-sticky', $(this).scrollTop() > 0);
		}
	});

	$(document).on("change", ".custom-select:not(.fareharbor-times)", function(){
		$(this).removeClass("empty");
		if ( $(this).find("option:selected").val() === '' ){
			$(this).addClass("empty")
		}
	})

	$(document).on('click', ".stickyFooterWrapper .check-availability-pg-btn, .c-product-pricing .check-availability-pg-btn", function(){
		if ( window.innerWidth <= 767 ){
			let widgetMobileWrapperEl = $(".widget-mobile-wrapper");
			if (widgetMobileWrapperEl.length) {
				$("html, body").animate({
					scrollTop:  widgetMobileWrapperEl.offset().top - 15
				}, 1000);
			}
		}
		else {
			let tmWidgetIframeEl = $(".activity-right .iframe-scroll");
		    if ( tmWidgetIframeEl.length ){
		    	if ( !isElementInViewport(tmWidgetIframeEl[0]) ){
					var scrollTopVal = 15;

					if ( document.querySelector("#s-page-container") !== null ){
						scrollTopVal = 100;
					}

			        $("html, body").animate({
			          scrollTop: tmWidgetIframeEl.offset().top - scrollTopVal
			        }, 1000);
		    	}
		    }
		}
	});

	if ( $(".stickyHeaderWrapper").length > 0 ){
		initStickyHeaders();
	}

	if ( $(".read-more-wrapper").length > 0 ) {
    $('.read-more-wrapper').each(function() {
        const $this = $(this);
        const linesOnlyShow = $this.data('only-show') || 3;
        const firstParagraph = $this.find('p').first();

        if (firstParagraph.length) {
            const eachLineHeight = parseFloat(firstParagraph.css('line-height')) || 30;
            const maxHeight = eachLineHeight * linesOnlyShow;

            if ($this.height() > maxHeight) {
                $this.addClass(`show-only-${linesOnlyShow}-lines hide-lines`);
                $this.append('<a href="#" class="read-more-link-with-icon no-color"><span>Read more</span><i class="far fa-chevron-down fa-xs" aria-hidden="true"></i></a>');
            }
        }
    });
	}

	if ( jQuery(".select-options-hour").length > 0 ){
		jQuery(".select-options-hour").on("change", function(){
			selectedHour = $(this).find("option:selected").val();

			$(document).trigger({
				type: 'priceComponent',
				componentRoot: $(this).parent().find('.c-product-pricing'),
				selectedOption: selectedHour.replace('option-', ''),
			});

			jQuery(".season-start-times > div").addClass("hidden");
			$("#" + selectedHour).removeClass("hidden");
		})
	}

	if ( $(".itemAttributesDescription").length > 0 ){
		initReadMoreStops(".what-to-expect-content > .itineraryStop .itemAttributesDescription", 4);
	}

	$(document).on("click", ".accessibility-link", function(e) {
		e.preventDefault(); // tm-accessibility.js opens the Accessibility Adjustments panel (capture listener); on a private page footer.php prints no panel and the link stays inert
	})

	makeReviewsMoreLinkClickable();
	makeAdditionalInfoSeeMoreClickable();

	if ( $(".activity-filter .filter-date-selection").length ){
		$("body").addClass("full-width-calendar");
		$(".activity-filter .filter-date-selection").on("click", function(){
			if ( isMobileDevice ){
				$("html, body").animate({
				scrollTop: $(".activity-filter").offset().top - 15
				}, 1000);
			}
		})
	}

	actionsBasedOnSupportTime();

	$.fn.extend({
			toggleText: function(a, b){
					return this.text(this.text() == b ? a : b);
			}
	});

	let agentNameFromQueryString = getQueryStringValueFromCurrentUrl('agent');
	if (agentNameFromQueryString.length > 0) {
		Cookies.set('agent_name', agentNameFromQueryString);
	}

	let discountCodeFromQueryString = getQueryStringValueFromCurrentUrl('discount');
	if (discountCodeFromQueryString.length > 0) {
		Cookies.set('coupon_code', discountCodeFromQueryString);
	}

	if ( $(".destination-landing-page-content .sidebar .closed").length > 0 ){
        jQuery(".sidebar .active").parents("ul").removeClass("closed");
        jQuery(".sidebar .active").parents("ul").prev('h3').toggleClass("open-heading")

        if ( jQuery(".sidebar .active").parents("ul").removeClass("closed").length == 0 ){
            jQuery(".sidebar .tours-sidebar:eq(0):not(.is-hotel-page)").removeClass("closed");
        }
	}

	if ( $(".sidebar h3").length > 0 ){
        jQuery(".sidebar h3").on("click", function(){
            $(this).next(".tours-sidebar").slideToggle();
            $(this).toggleClass("open-heading");
        })
    }

	$(".filter-heading .clear-btn").on("click", function(){
		const thing = $(this).parent().next('div');

		if ( thing.hasClass("price-filter-options") ){
			const my_range = thing.find(".js-range-slider").data("ionRangeSlider");
			 my_range.update({
						from: 0,
						to: 500
				});
			 my_range.reset();
			 ajaxReload();
		}

		if ( $(this).parents('.filter-option').find(".form-check-input").length > 0 ){
			const clearbtn = $(this).parents(".filter-option").find(".clear-btn");
			$(this).parents('.filter-option').find(".form-check-input[type='text']").val('');
			$(this).parents('.filter-option').find(".form-check-input").prop("checked",false).change();
			clearbtn.hide();
		}
	})

	// if ( $(".tabcontainer").length > 0 ){
	// 	$(".tabcontainer .tab").on("click", function(){
	// 		const selectedTab = $(this).data("fake-id");

	// 		$(this).siblings().removeClass("active_tab").end().addClass("active_tab");
	// 		$(this).parents(".tabcontainer").find(".tab_sections").children().hide();
	// 		$(this).parents(".tabcontainer").find(".tab_sections").find( selectedTab ).show();

	// 		if ( $(".scroll-slider").length > 0 ){
	// 			$(".scroll-slider").slick("refresh");
	// 		}
	// 	})
	// }

	addReadMoreReviewContent();

	loadActivityThumbsSliders();

	if ($(window).width() < 900) {
		initBrandItemsSlickSlider();
	}

	$(window).on('resize', function() {
	  if ($(window).width() < 900) {
	  	if (!$(".branding-items").hasClass('slick-initialized')) {
	    	initBrandItemsSlickSlider();
	    }
	  } else {
	  	if ($(".branding-items").hasClass('slick-initialized')) {
	    	destroyBrandItemsSlickSlider();
	    }
	  }
	});

	$(".filter-rating label label").on("click", function(){
		$(this).parents('.filter-rating').find(".filter-headings-font-weight span").show();
		if ( $(this).parents('.sidebar').length > 0 ){
		}
	});

	$(".filter-option input[type=checkbox]").on("click", function(){
		const clearbtn = $(this).parents(".filter-option").find(".clear-btn");
		const checkedOptions = $(this).parents(".filter-option").find(".form-check-input:checked").length;
		clearbtn.hide();
		if ( checkedOptions > 0 ){
			clearbtn.show();
		}
	});

	$("#ratngsFiltersHeading span, #ratngsFiltersHeadingMobile span").on("click", function(){
		$(this).parents('.filter-rating').find('input:checked').prop("checked",false);
		$(this).hide();
	})

	 $(".enhancedSafetyMeasures .collection__text__readmore").on("click", function(){
		 $('.enhancedSafetyMeasures .collection__text__readmore').toggle();
		 $("#safetyMeasuresList").toggleClass("content-show");
	 })

	$(document).on("click", ".read-more-review", function(e){
		e.preventDefault();

		$(this).parents('.review-body').toggleClass("closed opened");
		$(this).find("i").toggleClass("fa-chevron-down fa-chevron-up");

		if ( $(this).parents('.review-body').hasClass("opened") ){
			$(this).find("> span").text("Read less");
		}else{
			$(this).find("> span").text("Read full review");
		}
	})

	$(document).on("click", ".read-description", function(e){
		e.preventDefault();

		$(this).siblings('.description-content').toggleClass("closed opened");
		$(this).parents('#description-section').toggleClass("closed opened");
		$(this).find("i").toggleClass("fa-chevron-down fa-chevron-up");

		if ( $(this).siblings('.description-content').hasClass("opened") ){
			$(this).find("> span").text("Read less");
		}else{
			$(this).find("> span").text("Read more");
		}

	})

	$(document).on("click", ".itineraryStop + .read-more-link-with-icon", function(e){
		e.preventDefault();
		$(this).siblings('.itineraryStop').removeClass("hidden");
		$(this).siblings('.itineraryStop').removeClass("always-visible-item");
		$(this).remove();
	});

	$(document).on("click", ".read-more-area .read-more-link-with-icon, .seasonsWithPadding + .read-more-link-with-icon", function(e){
		e.preventDefault();

		if ( $(this).parents(".read-more-area").siblings('.listWrapper').length ){
			$(this).parents(".read-more-area").siblings('.listWrapper').find("li.hidden, li.show").toggleClass("show hidden");
			checkS = $(this).parents(".read-more-area").siblings('.listWrapper').find(".show").length;
			$(this).parents(".read-more-area").siblings('.listWrapper.closed').removeClass("closed");
			$(this).parents(".read-more-area").siblings('.listWrapper').find("li").addClass("all-devices-li-must");
			$(this).parents("#collapse-additional").find(".read-more-area").remove();
		}else{
			if ( $(this).parents(".season-start-times").length ){
				$(this).parent().find(".seasonsWithPadding li:not(.no-hidden)").toggleClass("show hidden");
				checkS = $(this).parent().find(".seasonsWithPadding li.show").length;
			}else{
				$(this).parents(".read-more-area").siblings('.hidden-para').toggleClass("show hidden");
				checkS = $(this).parents(".read-more-area").siblings('.hidden-para.show').length;
			}
		}

		if ( typeof checkS !== 'undefined' ){
			$(this).find("i").toggleClass("fa-chevron-down fa-chevron-up");

			if ( checkS ){
				$(this).find("> span").text("Read less");
			}else{
				$(this).find("> span").text("Read more");
			}
		}
	})

	$(document).on("click", ".read-more-content-area + .read-more-link-with-icon", function(e){
		e.preventDefault();
		const contentArea = $(this).prev('.read-more-content-area');
		contentArea.toggleClass('closed full');
		$(this).find("i").toggleClass("fa-chevron-down fa-chevron-up");

		if ( $(this).find("span").text() === "Read more" ){
			$(this).find("span").text('Read less');
		} else{
			$(this).find("span").text('Read more');
		}

	})

	$(document).on("click", ".read-more-wrapper .read-more-link-with-icon", function(e){
		e.preventDefault();
		const contentWrapper = $(this).parents('.read-more-wrapper');
		contentWrapper.toggleClass('hide-lines show-all-lines');
		$(this).find("i").toggleClass("fa-chevron-down fa-chevron-up");

		if ( $(this).find("span").text() === "Read more" ){
			$(this).find("span").text('Read less');
		} else{
			$(this).find("span").text('Read more');
		}

	})

	$(document).mouseup(function(e){
			var container = $(".duration-dropdown, .price-range-dropdown, .rating-dropdown, .filter-dropdown");

			// If the target of the click isn't the container
			if(!container.is(e.target) && container.has(e.target).length === 0){
					container.hide();
				}
		});

	refreshSliders( $(window) );

	var toolTipSelectors = ".review-source-wrapper, .excellence-badge, .badge, .likely-to-sell-out, .review-source-wrapper, .badge-of-excellenace-activity, .c-tooltip-wrapper";
	$(document).on("touchstart", function(event){
		// a touchstart with no touch point (synthetic or dispatched by a script) has nothing to record
		var touch = event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : null;
		toolTipTouchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
	});
	$(document).on("touchend", toolTipSelectors, toggleToolTip);

	// a tap anywhere else closes an open tooltip (product pages also do it in booking-widget.js; listings don't load that)
	$(document).on("touchend", function(event){
		if ( !toolTipTouchMoved(event) && !$(event.target).closest(toolTipSelectors).length ){
			$(".tooltip-cont, .c-tooltip-content").hide();
		}
	});


	if ( $("#full-width-slider #search-box-date-picker").length > 0 ){
		var picker = new Lightpick({
			field: document.getElementById('search-box-date-picker'),
			fieldWidth: true,
			minDate: moment(),
			singleDate: false,
			format: 'YYYY-MM-DD',
			hideOnBodyClick: true,
			numberOfMonths: parseInt(1),
			autoclose: false,
			footer: true,
			dropdowns: false,
			selectForward: true,
			orientation: 'bottom',
			locale: {
			  buttons: {
			    prev: '<i class="fa-solid fa-chevron-left"></i>',
			    next: '<i class="fa-solid fa-chevron-right"></i>',
			    reset: 'Reset',
			    apply: 'Apply'
			  },
			},
			onOpen: function(){
				var innerPicker = this;
				// Reset / Apply keep lightpick.js's own c-btn classes (M ghost / primary). Copying the banner search
				// button's "press custom-primary …" onto them turned Reset into white text on white.
				$(innerPicker.el).find(".lightpick__reset-action").addClass("c-resetAll");

				fixDatePickerStyling();
			},
			onSelect: function(start, end){
				tmVisitorStore.saveSelectedDates(start?.format('YYYY-MM-DD'), end?.format('YYYY-MM-DD'));

				var str = '';

				$(this._opts.field).css("text-indent", "-9999999px");
				if ( start && end && start._i == end._i ){
					str += start.format('MMM D');
					$(this._opts.field).next(".search-date-pretty-format").html(str);
				}
				else {
					if  ( start != null && end != null && start.format("YYYY-MM") === end.format("YYYY-MM")){
						$(this._opts.field).next(".search-date-pretty-format").html(  start.format("MMM D") + ' - ' + end.format("D") );
					}else{
						$(this._opts.field).next(".search-date-pretty-format").html( picker.toString('MMM D') );
					}
				}
				picker.setDateRange( start, end, true );
			},
		});
		picker.el.classList.add("home-calendar");
		home_picker_desktop = picker;
		attachNewArrowsEvents( picker );
	}

	// Modal open code
	$(document).on("click",".js-modal", function(e){
	  var modal_id = $(this).attr('href');
	  $(".modal-bg").removeClass("modal-show");
	  $(modal_id).addClass("modal-show");

		e.stopPropagation();
		e.preventDefault();
		$("body").css("overflow","hidden");

		if ( typeof $(this).data("parent") !== 'undefined' && $(this).data("parent").length > 0 ){
			$( "#" + $(this).data("parent") ).addClass("parent-back-popup");
		}
	});


	// When outside of modal is clicked, modal closes.
	$(document).click(function(e){
		const targetElement = $(e.target);
		if ( targetElement.is(".modal-bg") ){
	  		$(".modal-bg").removeClass("modal-show");
	  		$("body").css("overflow","auto");
			$(".parent-back-popup").removeClass("parent-back-popup");
	  	}
	});

	// Modal close button event
	$(document).on("click",".modal-close", function(e){
	    $(".modal-bg").removeClass("modal-show");
	  $("body").css("overflow","auto");
		$(".parent-back-popup").removeClass("parent-back-popup");
	});

	$(".sort-selected").on("click", function(e){
		$(".filter-dropdown").toggle();
	})

	$(".filter-dropdown .dropdown-item").on("click", function(e){
		$(".filter-dropdown").toggle();
		$(".filter-dropdown .dropdown-item-select").removeClass("dropdown-item-select");
		$(this).addClass("dropdown-item-select");
		$(".sort-selected span").text( $(this).text() );
	})

	if ( $(".js-range-slider").length > 0 ){
		var $range = $(".js-range-slider"),
				$inputFrom = $(".price-input-min .price"),
				$inputTo = $(".price-input-max .price"),
				instance,
				min = $range.data('min') || 0,
				max = $range.data('max') || 500,
				from = 0,
				to = 0;

		$(".price-range-dropdown").on("click", function(){
			if ( $inputTo.prop("value") >= 500 ){
				$inputTo.prop("value","500");
			}
		})

		$(".price-range-picker").on("click", function(e){
			if ( $(e.target).parents('.price-range-dropdown').length == 0 ){
				$(e.target).parents('.price-range-dropdown').toggle();

					if ( $inputTo.prop("value") >= 500 ){
						$inputTo.prop("value", to);
					}
			}
		})

		$range.ionRangeSlider({
				type: "double",
				min: min,
				max: max,
				from: $(".js-range-slider").data('from'),
				to: $(".js-range-slider").data('to'),
				prefix: '',
				max_postfix: "+",
				onStart: updateInputsFinish,
				onChange: updateInputsFinish,
				onUpdate: updateInputs,
				onFinish: (function(){
				var oldFrom = $(".js-range-slider").data('from');
				var oldTo = $(".js-range-slider").data('to');
				return function(data) {
					if( (data.from != oldFrom) || (data.to != oldTo) ) {
						oldFrom = data.from;
						oldTo = data.to;
						if(data.input.is('#act_price')) {
							ajaxReload();
						}
					}
				}
			})(),
				step: 1,
				skin: "round",
				force_edges: true,
				hide_min_max: true,
				hide_from_to: true
		});

		instance = $range.data("ionRangeSlider");

		function updateInputs (data) {
			const clearbtn = jQuery(data.input).parents(".price-filter-options").siblings('.filter-heading').find(".clear-btn");
			const leftPrice = jQuery(data.input).parents(".price-filter-options").find(".leftPrice");
			const rightPrice = jQuery(data.input).parents(".price-filter-options").find(".rightPrice");

				from = data.from;
				to = data.to;

				leftPrice.html(tmCurrency.getUsdCurrencyHtmlDataTag(0));
				rightPrice.html(tmCurrency.getUsdCurrencyHtmlDataTag(500) + '+');
				jQuery(document).trigger('tmPriceFilterSliderUpdated');
				clearbtn.hide();
		}

		function updateInputsFinish( data ){
			const clearbtn = jQuery(data.input).parents(".price-filter-options").siblings('.filter-heading').find(".clear-btn");
				clearbtn.hide();

				from = data.from;
				to = data.to;
				$inputFrom.prop("value", from);
				//$(".leftPrice").text( "$" +  from )
				$(data.slider).parents('.price-range-picker').find(".leftPrice").html(tmCurrency.getUsdCurrencyHtmlDataTag(from))

				if ( to < max || from > min ){
					clearbtn.show();
				}

				if ( to >= max ){
					$inputTo.prop("value", to);
					//$(".rightPrice").text( "$" +  to + "+" )
					$(data.slider).parents('.price-range-picker').find(".rightPrice").html(tmCurrency.getUsdCurrencyHtmlDataTag(to) + '+');
				}else{
					$inputTo.prop("value", to);
					//$(".rightPrice").text( "$" +  to )
					$(data.slider).parents('.price-range-picker').find(".rightPrice").html(tmCurrency.getUsdCurrencyHtmlDataTag(to));

				}

			if ( data.from == min && data.to == max ){
				$(data.slider).parents('.price-range-picker').find(".custom-text").val('').css("padding-top","0");
				$(data.slider).parents('.price-range-picker').find(".modern-placeholder").addClass("as-placeholder");

				//$(".price-range-picker .custom-text").val('').css("padding-top","0");
				//$(".price-range-picker .modern-placeholder").addClass("as-placeholder");
			}else{

				if ( data.to == max ){
					data.to = max;
				}

				$(data.slider).parents('.price-range-picker').find(".custom-text").val("$" + data.from + '-' + data.to).css("padding-top","19px");
				$(data.slider).parents('.price-range-picker').find(".modern-placeholder").removeClass("as-placeholder");

				//$(".price-range-picker .custom-text").val("$" + data.from + '-' + data.to).css("padding-top","19px");;
				//$(".price-range-picker .modern-placeholder").removeClass("as-placeholder");
			}

			jQuery(document).trigger('tmPriceFilterSliderUpdated');
		}

		$inputFrom.on("input", function () {
				var val = $(this).prop("value");
				// validate
				if (val < min) {
						val = min;
				} else if (val > to) {
						val = to;
				}

				instance.update({
						from: val
				});
		});

		$inputTo.on("input", function () {
				var val = $(this).prop("value").replace("+","");

				// validate
				if (val < from) {
						val = from;
				} else if (val > max) {
						val = max;
				}

				instance.update({
						to: val
				});
		});
	}

	if ( $(".activity-filter").length > 0 ){

		function applyButton(){
			console.log("asdasdasd");
		}

		if(document.getElementById('multi-date-selection')) {
			// The visitor's saved dates on a list's first page only: on page 2+ applying them would reload it to page 1 of
			// another list, so the visitor keeps the list they paged to and the filter shows no dates it doesn't apply
			var tmListPage = Math.max(Number((window.coolAjaxData || {}).paged) || 1, Number((window.coolAjaxData || {}).page) || 1);
			var tmStartDate = tmListPage === 1 ? tmVisitorStore.getSavedStartDate() : null;
			var tmEndDate = tmListPage === 1 ? tmVisitorStore.getSavedEndDate() : null;
			// pages with the date filter but no coolData printed (glossary, PostHog 019c2c1f) would throw on the bare coolData below
			window.coolData = window.coolData || [];

			picker_desktop = new Lightpick({
					field: document.getElementById('multi-date-selection'),
					singleDate: false,
					format: 'YYYY-MM-DD',
					minDate: moment().format('YYYY-MM-DD'),
					startDate: coolData['startDate'] ?? tmStartDate,
					endDate: coolData['endDate'] ?? tmEndDate,
					hideOnBodyClick: true,
					autoclose: false,
					footer: true,
					dropdowns: false,
					parentEl: '.filter-container-top',
					locale: {
					  buttons: {
					    prev: '<i class="fas fa-chevron-left"></i>',
					    next: '<i class="fas fa-chevron-right"></i>',
					    reset: 'Reset',
					    apply: 'Apply'
					  },
					},
					onSelect: function(start, end){
						tmVisitorStore.saveSelectedDates(start?.format('YYYY-MM-DD'), end?.format('YYYY-MM-DD'));

						if(start == null && end == null) {
							$('#multi-date-selection').val('');
							window.coolData['startDate'] = null;
                    		window.coolData['endDate'] = null;
							this.hide();
						}
						var str = '';
						document.getElementById('modern-date-placeholder').classList.remove("as-placeholder");

						//document.getElementById('multi-date-selection').style.paddingTop = "19px";
						if ( start && end && start._i == end._i ){
							str += start.format('MMM D');
							//document.getElementById('multi-date-selection').value = str;
							$(".filter-date-selection span").show().text(str);
							$(".c-search-control-style .c-search-dot").removeClass("c-hidden");
							$("#s-search-container-mobile-wrapper .c-search-date-text").text( str );
						}
						else {
							$(".c-search-control-style .c-search-dot").removeClass("c-hidden");

							if  ( start != null && end != null && start.format("YYYY-MM") === end.format("YYYY-MM")){
								$(".date-picker-desktop .filter-date-selection span").show().text( start.format("MMM D") + ' - ' + end.format("D") );
								$("#s-search-container-mobile-wrapper .c-search-date-text").text( start.format("MMM D") + ' - ' + end.format("D") );
							}else{
								//document.getElementById('multi-date-selection').value = str;
								$(".date-picker-desktop .filter-date-selection span").show().text( picker_desktop.toString('MMM D').replace("- ...","") );
								$("#s-search-container-mobile-wrapper .c-search-date-text").text( picker_desktop.toString('MMM D').replace("- ...","") );
							}
						}

						if(end && start && start.isAfter(end, 'day')) {
							$(".date-picker-desktop .filter-date-selection span").show().text( start.format('MMM D') );
						}

						if(start == null && end == null) {
							document.getElementById('modern-date-placeholder').classList.add("as-placeholder");
							$(".c-search-control-style .c-search-dot").addClass("c-hidden");
							$(".c-search-dates input").val("");
						}
					},
					onOpen: function(){
						$(".lightpick__reset-action").addClass( $(".fsFooterWrapper button#resetAll").prop("class") );
						$(".lightpick__apply-action").addClass( $(".fsFooterWrapper button:not(#resetAll)").prop("class") );
						document.getElementById('multi-date-selection').classList.add('active');
						fixDatePickerStyling();
					},
					onClose: function(){
						//$(".date-picker-desktop .filter-date-selection span").text( document.getElementById('multi-date-selection').value.replace(" - ...","") );
						var startDate = this.getStartDate();
						var endDate = this.getEndDate();
						if( (startDate && (startDate.format('YYYY-MM-DD') != coolData['startDate'])) || (endDate && (endDate.format('YYYY-MM-DD') != coolData['endDate'])) ) {
							coolData['startDate'] = startDate ? startDate.format('YYYY-MM-DD') : '';
							coolData['endDate'] = endDate ? endDate.format('YYYY-MM-DD') : '';
							picker_desktop._opts.onSelect.call(picker_desktop, picker_desktop.getStartDate(), picker_desktop.getEndDate());
							$('.filter-date-selection.custom-text').addClass('active').parents(".date-picker").addClass("date-selected");
							ajaxReload();
							/*sendVisitorAction({
								type: 'date_search',
								properties: {
									startDate: startDate.format('MMM Do YYYY'),
									endDate: endDate.format('MMM Do YYYY'),
									url: window.location.href,
								}
							}).done(function(response) {
								//console.log(response);
							});*/
						}
						else if(startDate == null && endDate == null) {
							$('.filter-date-selection.custom-text').removeClass('active').parents(".date-picker").removeClass("date-selected");
						}
						document.getElementById('multi-date-selection').classList.remove('active');
					}
			});
			picker_desktop.el.classList.add("filter-calendar");
			attachNewArrowsEvents( picker_desktop );

			if ( tmStartDate && tmEndDate && tmStartDate === tmEndDate ){
				picker_desktop.setDateRange( tmStartDate, null);   
			}

			if ( tmStartDate && tmEndDate && tmStartDate !== tmEndDate ){
				picker_desktop.setDateRange( tmStartDate, tmEndDate );      
			}
		}

		if(picker_desktop._opts) {
			if(window.coolData['startDate']) {
				$('.filter-date-selection.custom-text').addClass('active').parents(".date-picker").addClass("date-selected");
				picker_desktop._opts.onSelect.call(picker_desktop, picker_desktop.getStartDate(), picker_desktop.getEndDate());
			}
			else if(picker_desktop.getStartDate() && !picker_desktop.getStartDate().isBefore(moment(), 'day')) { // past saved dates: leave the list as it was
				// The visitor's saved dates (a search box's, in localStorage) that this page's list was built without —
				// pages are cached, so the server never sees them. Apply them like the date filter's Apply does, so the
				// results match the dates the filter shows.
				coolData['startDate'] = picker_desktop.getStartDate().format('YYYY-MM-DD');
				coolData['endDate'] = picker_desktop.getEndDate() ? picker_desktop.getEndDate().format('YYYY-MM-DD') : '';
				$('.filter-date-selection.custom-text').addClass('active').parents(".date-picker").addClass("date-selected");
				picker_desktop._opts.onSelect.call(picker_desktop, picker_desktop.getStartDate(), picker_desktop.getEndDate());
				ajaxReload({ scroll: false }); // on page load: no jump down to the filter bar
			}
		}


		$(".duration-selector").on("click", function(e){
			if ( $(e.target).parents('.duration-dropdown').length == 0 ){
				$(".duration-dropdown").toggle();
			}
		})

		$(".rating-selector").on("click", function(e){
			if ( $(e.target).parents('.rating-dropdown').length == 0 ){
				$(".rating-dropdown").toggle();
			}
		})

		$(".rating-dropdown .form-check").on("click", function(){
			$(".rating-selector .custom-text").val( $(this).data("label") ).css("padding-top","19px");
			$(".rating-selector .modern-placeholder").removeClass("as-placeholder");
		})

		$(".duration-selector input[type=checkbox]").on("click", function(){
			if ( $(".duration-selector input[type=checkbox]:checked").length == 1 ){
				$(".duration-selector .custom-text").val( $(".duration-selector input[type=checkbox]:checked").next("div").find(".text-body:eq(0)").text() ).css("padding-top","19px");
				$(".duration-selector .modern-placeholder").removeClass("as-placeholder");
			}else{
				$(".duration-selector .custom-text").val( '' ).css("padding-top","0");
				$(".duration-selector .modern-placeholder").addClass("as-placeholder");
			}

			if ( $(".duration-selector input[type=checkbox]:checked").length > 1 ){
				$(".duration-selector .modern-placeholder").text("Duration (" + $(".duration-selector input[type=checkbox]:checked").length + ")")
			}

			if ( $(".duration-selector input[type=checkbox]:checked").length < 2 ){
				$(".duration-selector .modern-placeholder").text("Duration")
			}
		})

		$(".activity-filter .date-picker").click(function(event) {
			//picker.hide();
		});


	}

	// iOS Safari fires "resize" on every scroll while the URL bar collapses/expands (height changes, width
	// does not). Re-initialising the sliders on those events re-inserted every card and replayed the card
	// reveal animation, which showed as flashing; only a real width change needs the sliders refreshed.
	let tmLastViewportWidth = $(window).width();
	$(window).on("resize", function(){
	    if ( typeof addReadMoreReviewContent === 'function' ){
	        addReadMoreReviewContent();
	    }
		const tmViewportWidth = $(window).width();
		if ( tmViewportWidth === tmLastViewportWidth ){
			return;
		}
		tmLastViewportWidth = tmViewportWidth;
		refreshSliders( $(this) );
	})

	if ( $("body").hasClass("single-activity") && window.location.hash == '#reviews' ){
			$('html, body').animate({
					scrollTop: $(".review").offset().top - 63
			}, 2000);
	}

	$(document).on("click", "#reviews .cd-pagination .pag-button a", function(e){
		e.preventDefault();
		if ( !$(this).hasClass("disabled") ){
			current_page =  parseInt( $("#reviews a.current").text() );

			if ( $(this).parent().hasClass("prev-btn") ){
				selected_page =  current_page - 1;
			}

			if ( $(this).parent().hasClass("next-btn") ){
				selected_page =  current_page + 1;
			}

			fetchReviews( selected_page, reviewsDetails['selectedRating'], true, false );
		}

	});

	$(document).on("click", "#reviews .cd-pagination .number a", function(e){
		e.preventDefault();
		current_page =  $(this).parents("#reviews").data("paged");
		selected_page =  $(this).data("page");

		$(this).parents("#reviews").data("paged", selected_page);

			fetchReviews( selected_page, reviewsDetails['selectedRating'], true, false );

	});

	$(".category-review-link, .category-read-more-link").on("click", function(e){
		if ( $(this).parents('.nw').length == 0 ){
			e.stopPropagation();
			window.location = $(this).prop("href");
		}
	});

	$(".edit-tour-link").off("click").on("click", function(e){
		e.preventDefault();
		window.open( jQuery(this).attr("href"), '_blank');
	})

	$(".reviews-area").on("click", function(e){
		e.preventDefault();
			$('html, body').animate({
					scrollTop: $(".review").offset().top
			}, 2000);
	})

	if ( $(".tours-sidebar .has_children").length > 0 ){


		$(".tours-sidebar:not(.filter-sidebar) .has_children .arrow").on("click", function(){
			if ( !$(this).hasClass("open") ){
				$(".tours-sidebar .has_children .arrow.open").next('.child-menu').slideToggle();
				$(".tours-sidebar .has_children .arrow.open").toggleClass('open');
			}
			$(this).toggleClass("open");
			$(this).next('.child-menu').slideToggle();
		});
	}


	$('a.share').click(function(e){
		e.preventDefault();
		var $link   = $(this);
		var href    = $link.attr('href');
		var network = $link.attr('data-network');

		var networks = {
				facebook : { width : 600, height : 300 },
				twitter  : { width : 600, height : 254 },
				google   : { width : 515, height : 490 },
				linkedin : { width : 600, height : 473 }
		};

		var popup = function(network){
				var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
				window.open(href, '', options+'height='+networks[network].height+',width='+networks[network].width);
		}

		popup(network);
	});

	$(".copy-text-a").click(function(e){
		e.preventDefault();

			var copyText = document.getElementsByClassName("copy-text")[0];


if ( isMobileDevice ) {
	var el = copyText;
	var editable = el.contentEditable;
	var readOnly = el.readOnly;
	el.contentEditable = true;
	el.readOnly = false;
	var range = document.createRange();
	range.selectNodeContents(el);
	var sel = window.getSelection();
	sel.removeAllRanges();
	sel.addRange(range);
	el.setSelectionRange(0, 999999);
	el.contentEditable = editable;
	el.readOnly = readOnly;
}else{
			/* Select the text field */
			copyText.select();
}

	 /* Copy the text inside the text field */
			document.execCommand("copy");

			/* Alert the copied text */
			$(".copy-link-text").text("Link Copied");
			setTimeout(function(args) {
				$(".copy-link-text").text("Copy Link");
			}, 500)
	});

	$(".share-dropdown-btn:not(.share-dropdown-btn--modal)").on("click", function(e){ // the modal variant is a data-modal-target trigger
		e.preventDefault();
		$(this).parent().toggleClass('open');
		$(".share-dropdown").find("ul").toggle();
	});

	if ( $(".left-inner").find("span[id^=more-]").length > 0 ){
		left_inner_p_lengths = $(".left-inner").find("p").length;
		left_inner_ul_ol_lengths = $(".left-inner ul, .left-inner ol").length;
		if ( left_inner_p_lengths > 1 || left_inner_ul_ol_lengths > 0 ){
			read_more_top = $(".left-inner").find("span[id^=more-]").position().top;
			first_para_top = $(".left-inner").find("p").eq(0).position().top;
			distance_between_read_first = (read_more_top - first_para_top) + 3;
			$(".left-inner").css( { "height": distance_between_read_first + "px", "position": "relative", "overflow": "hidden"} );
			$(".left-inner").find("span[id^=more-]").addClass("read_more_gradient");
			$(".left-inner").after('<a class="read_more_text" href="#">Read More</a>');
			$(".read_more_text").on("click", function(e){
				e.preventDefault();
				$(this).toggleClass("less_text");

				//$(this).remove();
				if ( $(this).text() == 'Read More' ){
					$(".read_more_gradient").hide();
					$('.left-inner').addClass("show_all_text");
					$(this).text("Show Less");
				}else{
					$(".read_more_gradient").show();
					$('.left-inner').removeClass("show_all_text");
					$(this).text("Read More");
				}
			});
		}
	}

	if ( typeof link_color != 'undefined' ){
		jQuery(".inner-columns a, .single-activity .right-section a:not(.pag_color), .call_page a, .learn-more, .modal-content a, .account-link, .shared-policy .content a, .enhancedSafetyMeasures a, .collection__text__readmore i, #ratngsFiltersHeading span, #ratngsFiltersHeadingMobile span, .linkCancellation, .review-more-link, .stickyFooterWrapper .lowestPriceLink").addClass(link_color);
		jQuery(".inner-columns a.no-color, .single-activity .right-section a.no-color, .call_page a.no-color, .learn-more.no-color, .modal-content a.no-color, .account-link.no-color, .shared-policy .content a.no-color, .enhancedSafetyMeasures a.no-color, .collection__text__readmore i.no-color, #ratngsFiltersHeading span.no-color, #ratngsFiltersHeadingMobile span.no-color").removeClass(link_color);

	}

	$(".back-to-top").on("click", function(e){
		e.preventDefault();
		$(".modal-bg").animate({scrollTop : 0},700)
	})

	$(".mobile-safety-measures").on("click", e => {
		e.preventDefault();
		//$("#safety-measures-modal").toggleClass('modal-show');

		if ( $("#safety-measures-modal").find(".enhancedSafetyMeasures").length == 0 ){
			$("#safety-measures-modal .modal-header").html('<span class="modal-close"><i class="fal fa-times" aria-hidden="true"></i></span><h2 class="desktop-only"><span class="mr-2"><i class="fal fa-hands-wash" aria-hidden="true"></i></span>Keeping you safe during COVID-19</h2>');
			$("#safety-measures-modal .modal-content").append( $(".enhancedSafetyMeasures.desktop-only").clone() )
			$("#safety-measures-modal .modal-content .enhancedSafetyMeasures").removeClass("desktop-only");
		}
	})

	$(".shared-policy .has-text-align-right").on("click", function(e){
		e.preventDefault();
		$("html").animate({scrollTop : 0},700)
	})

	$("#main-nav .nav-link-dropdown").hoverIntent({
				over: function() {
						openNavDropdown(this);
				},
				out: function() {
					$(this).removeClass("active");
						$(this).find(".section-nav-dropdown").removeClass("nav-open")
				},
				interval: 50,
				timeout: 200
		})

	jQuery(".result-area").on("click", ".result", function(){
		if ( $("body.home").length && $("#search-box-date-picker").length && !$(this).hasClass("activity") ){
			$(".search-form .search-field").val( $(this).find(".c-full-title-search").text() );
			$("#search-box-date-picker").click();
			searchLinkFlag = true;
			selectedSearchLink = $(this).data("url");
		}else{
			searchLinkFlag = false;			
			window.location = $(this).data("url");
		}
	})

	jQuery('.search-form form').on('submit', function(event){
        var destinations = $(this).find('.destination-results .destination');
        if(destinations.length == 1 && event.originalEvent) {
        	window.location = jQuery(destinations.get(0)).data('url');
        	event.preventDefault();
        }
	});

	jQuery(".result-area").on("click",".more-results", function(){
		$(this).parents(".search-form").submit();
	})

	jQuery(".search-form .icon-search, #search-outside-button").on("click", function(){
		if ( jQuery.trim( $(this).parents('.search-form').find(".search-field").val() ).length > 0 ){
			$(this).parents(".search-form").submit();
		}
	})

	jQuery(".disable-all").on("click", function(){
		$(this).hide();
		$(".alternate-search").hide();
		if ( $(".activity-filter").length ){
			$(".activity-filter").removeClass('open');
			$('body').css('overflow', 'auto');
			$('html').removeClass('filtersOpen');
		}
		tmFiltersApplyPending(); // closing the panel by tapping outside still applies what was changed
	})

	jQuery(".search-form .icon-close").on("click", function(){
		$(this).hide();
		$(this).parents(".search-form").find(".search-field").val("");
	})

	jQuery(".fsHeader i").on("click", e => {
		e.preventDefault();
		$("body.desktop #filter-mobile").removeClass("open");
		$("body.desktop .disable-all").hide();
		$('body').css('overflow', 'auto');
		$('html').removeClass('filtersOpen');
		tmFiltersApplyPending(); // closing with the X still applies what was changed

		if ( $("body.mobile").length ){
			$(".activity-filter").removeClass("open");
			$(".activity-filter").addClass("closing");

            modalTimeOutMs = 550;

            setTimeout( () => {
                $(".sidebar.filter-container").removeClass("open");
				$(".activity-filter").removeClass("closing");
            }, modalTimeOutMs);
		}
	})

	jQuery(".filters-button").on("click", e => {
		e.preventDefault();
		$(".disable-all").show();
		$("#filter-mobile").addClass("open");
		$('html').addClass('filtersOpen');
		setTimeout(function(){
			$('body').css('overflow', 'hidden');
		}, 500);
	})

	jQuery(".service-buttons .alt-icon").on("click", function(e){
		e.preventDefault();
		$("#main-header-middle .alternate-search").show();
		$("#main-header-middle .search-field:visible").focus();
		//$("#main-header-middle .search-field:visible").val('');
		$(".disable-all").show();
	})

	jQuery(document).on("click", "body.mobile .cruise-filters",  function(e){
		$("#c-start-your-search").addClass("show");
		$(".s-search-container-mobile").show();
		$("body").addClass("start-your-search-opened");
		$("body").addClass("body-no-scroll");
		$("#c-start-your-search .c-search-for-place-or-activity input").focus()
	});

	jQuery(".search-box .search-btn-col a").on("click", function(e){
		e.preventDefault();

		if ( !searchLinkFlag ){
			if ( jQuery.trim( $(".search-box .search-field").val() ).length > 1 ){
				$(".search-box .search-form").submit();
			}else{
				$(".search-box .search-field").focus();
			}
		}else{
			if ( home_picker_desktop !== 'undefined' && selectedSearchLink.length > 0 && home_picker_desktop.getStartDate() !== null ){
				start = home_picker_desktop.getStartDate()?.format("YYYY-MM-DD");
				end = home_picker_desktop.getEndDate()?.format("YYYY-MM-DD");
				if ( start && end ){
            		tmVisitorStore.saveSelectedDates(start, end);
				}
				if ( start && !end ){
					tmVisitorStore.saveSelectedDates(start, null);
				}
                window.location.href = selectedSearchLink;
			}

			if ( selectedSearchLink.length > 0 && home_picker_desktop.getStartDate() === null  ){
				window.location.href = selectedSearchLink;
			}
		}	
	})

	currentSearch = $("div.search-form:visible");

	jQuery(".search-field").keyup(function(e) {
		currentSearch = $(this).parents("div.search-form");
			clearTimeout($.data(this, 'timer'));
			if (e.keyCode == 13){
				search(true);
			}else{
				$(this).data('timer', setTimeout(search, 200));
			}
	});

	jQuery(".search-field").click(function(e) {
		var target = $(e.currentTarget);
		if(target.val()) {
			target.trigger('keyup');
			e.stopPropagation();
			e.preventDefault();
		}
	});

	var search_ajax = {abort: function () {}};

	function search(force) {
			var existingString = jQuery.trim( $(currentSearch).find(".search-field").val() );

			if ( existingString.length == 0 ){
			$(currentSearch).find(".icon-close").hide();
			}

			if (!force && existingString.length < 3){
				$(currentSearch).find(".result-area").empty();
				return; //wasn't enter, not > 2 char
		}

		if ( existingString.length > 0 ){
			$(currentSearch).find(".icon-close").show();
		}

		// Clicking the field again re-triggers this (see the .search-field click handler
		// below), but closing the results via the outside-click handler only hides
		// .result-area - it never empties it. If the text hasn't changed since the last
		// completed search, those results are still sitting there - just leave them shown
		// instead of re-hitting the AJAX endpoint for an identical query.
		if ( $(currentSearch).data("lastSearchedText") === existingString && $(currentSearch).find(".result-area").children().length > 0 ){
			return;
		}

		var data = {
			'action': 'search_form',
			'search_text': existingString,
		};

		$(currentSearch).find("label .icon-search.in-icon").hide();
		$(currentSearch).find(".lds-ring").show();

		search_ajax.abort();
		search_ajax = jQuery.post(ajaxurl, data, function(response) {
			$(currentSearch).data("lastSearchedText", existingString);
			$(currentSearch).find("label .icon-search.in-icon").show();
			$(currentSearch).find(".lds-ring").hide();
			$(currentSearch).find(".result-area").empty().append(response);
			jQuery(document).trigger('searchResultsUpdated');
		});

	}

	jQuery(".search-field").on("keyup", function(){
		search_value = jQuery.trim($(this).val());
		result_area = $(this).parents('.search-form').find(".result-area");
		if ( search_value.length > 0 ){
			if ( !$(result_area).is(":visible") ){
				$(result_area).show();
			}
		}else{
			$(result_area).hide();
		}
	})

	jQuery(".search-field").on("keypress", function(){
		search_value = jQuery.trim($(this).val());
	});

	jQuery(".search-field").on("click", function(){
		parentP = $(this).parents(".search-form");
		search_value = jQuery.trim($(this).val());
		if ( search_value.length > 0 ){
			if ( !$(parentP).find(".result-area").is(":visible") ){
				$(parentP).find(".result-area").show();
			}
		}
	})

	$(document).click(function(e){
			var container = $(".result-area");

			// if the target of the click isn't the container nor a descendant of the container
			if (!container.is(e.target) && container.has(e.target).length === 0)
			{
					container.hide();
					//$(".share-dropdown").removeClass("open");
			}
	});

	jQuery(".left-inner .learn-more").on("click", function(){
		jQuery(this).parent().toggleClass("all");
		jQuery(this).toggleText( "Read More", "Show Less" );


	})

	jQuery("#category-dropdown, .category-dropdown").on("change", function(e){
		selectedOption = jQuery(this).find("option:selected");
		if ( typeof selectedOption.data("link") !== 'undefined' ){
			window.location = selectedOption.data("link");
		}
	})

	jQuery(".move-to-widget").on("click", function(e){
		e.preventDefault();
		jQuery('html, body').animate({
					scrollTop: jQuery(".iframe-scroll").offset().top - 20
			}, 1000);

	})

	jQuery(document).on("click", ".listing-group:not(.enable-suppress-activity) li",  function(e){
		console.log("woww");
		if ( $(this).hasClass("nw") ){
			if ( $(e.target).closest(".favorite-icon").length === 0 ){
				window.open( jQuery(this).find(".listing-desc h3 a").attr("href"), '_blank');
			}
		}else{
			if ( $(e.target).closest(".favorite-icon").length === 0 ){
				window.location = jQuery(this).find(".listing-desc h3 a").attr("href");
			}
		}
		e.preventDefault();
	});
	jQuery(".nw a").on("click", function(e){
		e.preventDefault();
	});


	jQuery(document).on('click', 'a.suppress-review', function(e) {
		e.preventDefault();
		var suppressReviewId = $(this).attr('data-review-id');
		if(suppressReviewId) {
			$(this).next('.fas').show();
			jQuery.post(ajaxurl, { action: 'tm_suppress_review', tm_review_id : suppressReviewId}, function(response) {
				var jsonResp = JSON.parse(response);
				if(jsonResp.status) {
					$('#review-item-' + suppressReviewId).remove();
				}
			})
		}
	});

	jQuery(document).on('click', 'a.highlight-review', function(e) {
		e.preventDefault();
		var highlightReviewId = $(this).attr('data-review-id');
		if(highlightReviewId && $(this).text() !== 'Highlighted') {
			$(this).next('.fas').show();
			var that = $(this);
			jQuery.post(ajaxurl, { action: 'tm_highlight_review', tm_review_id : highlightReviewId}, function(response) {
				var jsonResp = JSON.parse(response);
				if(jsonResp.status) {
					that.next('.fas').hide();
					that.text('Highlighted')
				}
			})
		}
	});

	jQuery(document).on('click', 'a.suppress-activity', function(e) {
		var suppressActivityId = $(this).attr('data-activity-id');
		var activityDestinationSlug = $(this).attr('data-destination-slug');
		var sharedCategoryId = $(this).attr('data-shared-category-id');
		e.preventDefault();
		$(this).next('.fas').show();
		var that = $(this);
		var thatText = $(this).text();
		var topThat = $(this).siblings(".manage-top-tour");

		if(suppressActivityId) {
			if ( $(this).text() === 'Killed' ){
				thatText = 'Kill';
			}
			else{
				thatText = 'Killed';
			}
		}

		jQuery.post(ajaxurl, {
			action: 'tm_suppress_activity',
			tm_activity_id : suppressActivityId,
			tm_destination_slug : activityDestinationSlug,
			tm_shared_category_id : sharedCategoryId,
			nonce: tmUtils.getAjaxRequestNonce(),
		}, function(response) {
			var jsonResp = JSON.parse(response);
			if(jsonResp.status) {
				that.next('.fas').hide();
				that.text(thatText)
				that.toggleClass("c-suppressed-activity");
				topThat.toggleClass("c-hidden");
			}
		})
	});

	jQuery(document).on('click', 'a.manage-top-tour', function(e) {
		var activityId = $(this).attr('data-activity-id');
		var activityDestinationSlug = $(this).attr('data-destination-slug');
		if(activityId) {
			e.preventDefault();
			$(this).next('.fas').show();
			var that = $(this);
			var suppressedThat = $(this).siblings(".suppress-activity");
			jQuery.post(ajaxurl, { action: 'tm_add_top_tour', tm_activity_id : activityId, tm_destination_slug : activityDestinationSlug }, function(response) {
				var jsonResp = JSON.parse(response);
				that.removeClass("good-color-bg-color");
				that.next('.fas').hide();
				if(jsonResp.status) {
					if ( jsonResp.top ){
						that.addClass("good-color-bg-color");
						suppressedThat.addClass("c-hidden");
					}else{
						suppressedThat.removeClass("c-hidden");
					}
				}
			})
		}
	});

	jQuery(document).on('click', 'a.suppress-supplier', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var suppressSupplierId = $(this).attr('data-supplier-id');
		var activityDestinationSlug = $(this).attr('data-destination-slug');
		var sharedCategoryId = $(this).attr('data-shared-category-id');
		if(suppressSupplierId && $(this).text() !== 'Killed') {
			$(this).next('.fas').show();
			var that = $(this);
			jQuery.post(ajaxurl, {
				action: 'tm_suppress_supplier',
				tm_supplier_id : suppressSupplierId,
				tm_destination_slug : activityDestinationSlug,
				tm_shared_category_id : sharedCategoryId,
				nonce: tmUtils.getAjaxRequestNonce()
			}, function(response) {
				var jsonResp = JSON.parse(response);
				if(jsonResp.status) {
					that.next('.fas').hide();
					that.text('Killed')
				}
			})
		}
	});

	jQuery(document).on("click", ".product-list .product-card:not(.carousel-product-card)", function(e){
		if ( jQuery(e.target).parents('.favorite-icon').length || jQuery(e.target).is('.favorite-icon') ){
			return;
		}
		if ( jQuery(e.target).closest('.c-card-slider__prev, .c-card-slider__next, .c-card-slider__dots, .c-card-slider__slide a').length ){
			return; // the card's photo slider (product-card-slider.js): arrows, dots and the excerpt's More link keep their own click
		}
		if ( $(this).parents('.wish-list-carousel') ){
			//window.location = jQuery(this).find("a").attr("href");
			window.open( jQuery(this).find("a").attr("href"), jQuery(this).find("a").attr("target"));
			return false;
		}

		if(e.target.classList.contains('suppress-supplier') || e.target.classList.contains('suppress-activity') || e.target.classList.contains('manage-top-tour')) {
			return;
		}
		window.location = jQuery(this).find("a").attr("href");
	})

	$(document).on("click", ".product-card.full-link", function(e){
		if ( !jQuery(e.target).is("a") ){
			jQuery(this).find("a:eq(0)")[0].click();
		}
	})

	jQuery(document).on("click", ".accordion:not(.always-opened), #collapse-faq .faq-item", function(){
		dId = jQuery(this).data("id");
		jQuery("#" + dId).slideToggle(400);
		jQuery(this).toggleClass("close open");

			// jQuery('html, body').animate(
			//   {
			//     scrollTop: jQuery(jQuery(this)).offset().top - 20,
			//   },
			//   500,
			//   'linear'
			// )
	})
	var dragging, href, el;
	dragging = false;
	href = '';

	$('.right-arrow-slider-left a, .left-arrow-slider-right a').mousedown(function() {
		el = $(this);
		dragging = false;
		href = $(this).attr('href');
	}).mousemove(function() {
			dragging = true;
		}).mouseup(function() {
			var wasDragging;
			wasDragging = dragging;
			dragging = false;
			if (wasDragging) {
						$(this).attr('href', null);
						if ( $(".service-top").length > 0 ){
							$(".service-top").off("click");
						}
						setTimeout((function() {
						el.attr('href', href);
						if ( $(".service-top").length > 0 ){
					$(".service-top").on("click", function(){
						$(this).find("a:eq(0)").click();
					})
						}
					}), 10);
			 }
		});

	if ( $(".service-gallery").length > 0 ){
		$(".service-gallery").each( function(){
			$(this).find("a").simpleLightbox();
		})

		$(".service-top").on("click", function(){
			$(this).find("a:eq(0)").click();
		})
	}

	$('#locations-menu').click(function(e){
		e.preventDefault();

		$(".menu-nav > div").hide();


		if  ( !$("html").hasClass("menu-open") && $('.locations-menu').is(":visible") == false ){
			$('.menu-nav').slideToggle();
			$('.locations-menu').show();
		}


		$("html").removeClass("menu-open");
		$("#main-menu").removeClass("open");

		if  ( $("html").hasClass("menu-open") && $('.locations-menu').is(":visible") == false ){
			$('.locations-menu').show();
		}

		if  ( !$("html").hasClass("menu-open") && $('.locations-menu').is(":visible") == false ){
			$('.locations-menu').show();
		}

	 //  }else{
		//   $('.locations-menu').show();

		//   $('.menu-nav').slideToggle();
		//   $(this).toggleClass('open');
		//   $("html").toggleClass("menu-open");
		//   $('.js-toggle-menu').toggleClass('open');
		// }
	});

	$('.js-toggle-menu').click(function(e){
		e.preventDefault();
		activeDropdown = null;

		if ( $('.js-toggle-menu').hasClass("open") == true ){
			$('.js-toggle-menu').toggleClass('open');
			$("html").toggleClass("menu-open");
			$('.menu-nav').slideToggle();
			$(".filters-button").css("visibility","visible");
		}else{
			$(".filters-button").css("visibility","hidden");
		// if  ( $("html").hasClass("menu-open") && $('.locations-menu').is(":visible") == true ){
		 //  $('.menu-nav').slideToggle();

		 //  $('.js-toggle-menu').toggleClass('open');
		 //  $("html").toggleClass("menu-open");
		// }else{
		if ( $('.locations-menu').is(":visible") == false ){
			$('.menu-nav').slideToggle();

		}
			$(".menu-nav > div").hide();

//		  $('.main-menu').show();
			$('.js-toggle-menu').toggleClass('open');
			$("html").toggleClass("menu-open");
		//}

		//if ( $('.locations-menu').is(":visible") == true ){

			$('.main-menu').show();


	}
		//}


	});

	if ( $("#reviews").length ){
		fetchReviews( 1, 0, false ); // the first page of reviews, with no scrolling on page load (public: no nonce to wait for)
	}
	loadProductReviewPhotos(); // product pages only, as the next
	loadProductFeaturedReview();
	loadReviewCarousels();
	// HTML inserted later: the homepage's blocks (a homepage cached before the carousels moved to AJAX has an inline
	// loader that only fires this event) and grid re-renders; a frame already asked is skipped
	$(document).on('tmActivitiesSubsetListRefreshed', function(){
		loadReviewCarousels();
	});

	if ( $("#reviews").length ){
		$(".stars-progress-row .clickable").on("click", function(){
			const progress_row = $(this).parents('.stars-progress-number');
			let ratingSelected = Math.abs( progress_row.index() - 5);
			if ( reviewsDetails['selectedRating'] === ratingSelected ){
				ratingSelected = 0;
			}
			reviewsDetails['selectedRating'] = ratingSelected;

			if ( ratingSelected > 0 ){
				$(progress_row).addClass("selectedProgress").siblings().removeClass("selectedProgress");
				$(".reviewCount").html( reviewsDetails['star' + ratingSelected ] + " reviews <span class='clearFilter " + link_color + "'>(Clear Filter)</span>");
			}else{
				$(progress_row).removeClass("selectedProgress").siblings().removeClass("selectedProgress");
				$(".reviewCount").html( reviewsDetails['totalReviews'] + " reviews");
			}

			fetchReviews( 1, ratingSelected );
		});

		$(document).on("click","#reviewDetails .clearFilter", function(){
			reviewsDetails['selectedRating'] = 0;
			$(".stars-progress-number").addClass("selectedProgress").siblings().removeClass("selectedProgress");
			$(".reviewCount").html( reviewsDetails['totalReviews'] + " reviews");
			$(this).remove();
			fetchReviews( 1 );
		});
	}

});



// The results count of an activity-tabs page follows the open tab: the cards in its panel
function updateActivityTabsCount() {
	// the clicked pill keeps aria-selected in step with c-btn-selected (tab-navigation.js moves the class)
	var $pills = $('.c-activity-tabs .c-activity-tab');
	$pills.each(function() { $(this).attr('aria-selected', $(this).hasClass('c-btn-selected') ? 'true' : 'false'); });
	var $panel = $('.c-activity-panels .c-tab-navigation-content:not(.c-hidden)');
	if ($panel.length) {
		$('#totalActivities').text($panel.find('.c-product-list-item').length.toLocaleString('en-US'));
	}
}
$(function() {
	updateActivityTabsCount();
	// delegated, bound after tab-navigation.js's own handler on the tab, so the panel has switched when this runs
	$(document).on('click', '.c-activity-tabs .c-activity-tab', updateActivityTabsCount);
});

ajaxReload = (function(){
	var xhr;
	return function(options = {}) {

		if(!window.coolAjaxData) {
			return;
		}

		if ( !isMobileDevice && options.scroll !== false ){
			$('html, body').animate({
				scrollTop: $(".filter-container-header").offset().top - 80
			}, 0);
		}

		// the open activity tab (shared category post with tabs), before the skeleton replaces the results: the reply opens it again
		var $openActivityTab = $('.c-activity-tabs .c-activity-tab.c-btn-selected');
		if ($openActivityTab.length) {
			window.coolAjaxData.activity_tab = $('.c-activity-tabs .c-activity-tab').index($openActivityTab);
		}
		else {
			delete window.coolAjaxData.activity_tab;
		}

		var layout = $(".activity-sort .c-switch-radio-inner :checked").val();
		var $listingSkeleton = $('#tm-listing-skeleton');
		var previousResultsHtml = null;

		$(window.coolData.hideOnSearchSelectors).addClass("hide-on-search");
		if ($listingSkeleton.length) {
			previousResultsHtml = $(window.coolData.updateSelectors).html();
			// Replace the results with same-size placeholder cards (template in sort-filter.php)
			// instead of the fixed-height "Loading Options" box, so the page does not jump.
			$(window.coolData.updateSelectors)
				.removeClass("hide-on-search")
				.addClass("grid-product-list-loading-skeleton")
				.html('<div class="row mt-3 product-list">' + $listingSkeleton.html() + '</div>');
		} else {
			$(".filter-loader").show();
		}

		if ( layout === 'list' ){
			$("body").addClass("list-ajax-loading");
		}else{
			$(".sidebar.filter-container, #filter-mobile").removeClass("open");
			$("html.filtersOpen").removeClass("filtersOpen");
			$('body').css('overflow', 'auto');
		}


		window.coolAjaxData.f = $('#main-content-area input, #main-content-area select').serialize();

		let ttdHighlightActivityId = typeof tmUtils !== "undefined" ? tmUtils.getParameterFromUrl('q_activity_id', window.location.href) : null;
		if (ttdHighlightActivityId !== null) {
			window.coolAjaxData.q_activity_id = ttdHighlightActivityId;
		}
		showFiltersCount();

		if ( !isMobileDevice ){
			$(".sidebar").hide();
		}

		if(xhr && xhr.abort) {
			xhr.abort();
		}
		window.myhhr = xhr = $.ajax({
			type: 'POST',
			url: ajaxurl,
			data: window.coolAjaxData,

			success: function(textStatus){
				var layout = $(".activity-sort .c-switch-radio-inner :checked").val();
				var tmp = $('<div>');

				if ( layout === 'list' ){
					$(".content").addClass("c-is-list");
					$(".content").removeClass("c-is-grid");
				}else{
					$(".content").removeClass("c-is-list");
					$(".content").addClass("c-is-grid");
				}

				tmp.html(textStatus);
				$(tmp).find('#new-pagination a').each((i, el) => {
					let url = new URL(window.coolData.firstPageUrl);
					url.search = '';
					var firstPageUrl = url.toString();
					if(!firstPageUrl.endsWith('/')) {
						firstPageUrl += '/';
					}
					// the AJAX pagination's links are relative: page/2/… and the first page's "" or "?filter=…", which
					// left as it is would resolve against the page the visitor is on (page/6/ for "1")
					var href = $(el).attr('href') || '';
					if(href.startsWith('page') || href.startsWith('?') || href === '') {
						$(el).attr('href', firstPageUrl + href);
					}
				});

				// written once: the cards in the product-list row (a layout set), "No activities found." as it is
				var resultsHtml = tmp.html();
				if ( resultsHtml.indexOf('No activities found.') === -1 && typeof layout === 'string' && !tmp.find('.c-activity-panels').length ){ // a tabbed reply is the panels block, which holds its own product-list rows
					resultsHtml = '<div class="row mt-3 product-list">' + resultsHtml + '</div>';
				}
				$(window.coolData.updateSelectors).html(resultsHtml);
				updateActivityTabsCount(); // the reply's sort-section script set the union count; the open tab's replaces it
				// the line over a type its filters left empty (load_activities lists all of its tours) goes above the
				// cards' grid, not into its first cell (activityFiltersRelaxedHtml)
				$(window.coolData.updateSelectors).find('.product-list > .c-no-products').each(function() {
					$(this).insertBefore($(this).parent());
				});

				if ( !isMobileDevice && layout === 'list' ){
					$(".sidebar").show();
				}

				$('.cd-pagination a').each(function() {
					if(($(this).attr('href') || '').charAt(0) === '#') {
						return; // a disabled Prev / Next: no page, it stays "#" (not this page's address + "#")
					}
					var url = new URL($(this).attr('href'), window.location.href);
					if(window.coolAjaxData.sortBy == 'featured') {
						url.searchParams.delete('sortBy');
					}
					else {
						url.searchParams.set('sortBy', window.coolAjaxData.sortBy);
					}
					$(this).attr('href', url.href);
				});

				$(".filter-loader").hide();
				$(window.coolData.hideOnSearchSelectors).removeClass("hide-on-search");
				$(window.coolData.updateSelectors).removeClass("grid-product-list-loading-skeleton");
				$("body").removeClass("list-ajax-loading");

				var url = new URL(window.coolData.firstPageUrl);

				if(window.coolAjaxData.sortBy != 'featured') {
					url.searchParams.set('sortBy', window.coolAjaxData.sortBy);
				}

				var filterId = $('[data-filterid]').data('filterid');
				if(filterId) {
					url.searchParams.set('filter', filterId);
				}

				if(layout) {
					url.searchParams.set('layout', layout);
				}

				// the reloaded list is always its first page (load_activities), whatever page it was on: no page in the URL,
				// none in the title (WordPress's " – Page 6")
				window.history.pushState({}, '', url);
				document.title = document.title.replace(/ \u2013 Page \d+$/, '');

				// the response's pagination (components/pagination, page 1 already current) takes the page's place; none in
				// the response = one page of results. A page opened with one page of results has none to replace: it goes
				// where the template prints it, after the results
				var $newPagination = jQuery('#new-pagination > nav');
				var $pagePagination = jQuery('nav[role=navigation]').not('#new-pagination > nav');
				if($newPagination.length) {
					if($pagePagination.length) {
						$pagePagination.replaceWith($newPagination);
					}
					else {
						$newPagination.insertAfter($(window.coolData.updateSelectors).last());
					}
				}
				else {
					$pagePagination.hide();
				}
				jQuery(document).trigger('tmActivitiesFiltersApplied');
				jQuery(document).trigger('tmActivitiesSubsetListRefreshed');
			},
			error: function(MLHttpRequest, textStatus, errorThrown){
				if (textStatus === 'abort') {
					return; // superseded by a newer reload
				}
				if (previousResultsHtml !== null) {
					$(window.coolData.updateSelectors).html(previousResultsHtml); // put the old results back
				}
				$(".filter-loader").hide();
				$(window.coolData.hideOnSearchSelectors).removeClass("hide-on-search");
				$(window.coolData.updateSelectors).removeClass("grid-product-list-loading-skeleton");
				$("body").removeClass("list-ajax-loading");
			}
		});
	};
})();

function showFiltersCount() {
	var filters = $('#main-content-area input:not(.c-switch-radio-item):not(.multi-date-selection), #main-content-area select').serializeArray();

	filters = filters.filter(function(element){
		return (element.value == '' || element.value=='0;500') ? false : true;
	});

	var totalFiters = filters.length;

	var textContainer = $('.filters-button.mobile-only span');
	var desktopCount = $(".filter-popup .c-btn-count"); // the chip keeps "Filter"; the count is a badge (Peter, 2026-09-18)
	var filterPopup = $(".filter-popup");

	if(totalFiters > 0) {
		filterPopup.addClass("active");
		textContainer.text('Filter (' + totalFiters + ')');
		desktopCount.text(totalFiters);
	}
	else {
		filterPopup.removeClass("active");
		textContainer.text('Filter');
		desktopCount.text('');
	}

}

jQuery(function($){
	window.coolData = window.coolData || [];

	$(document).on('click', '.c-resetAll', function(){
		window.scrollTo(0,0);
		$('input[name="f[tr]"]').remove(); // the hidden total-reviews field has no Clear button of its own; first, so the Price Clear's reload cannot send it
		$(".filter-heading .clear-btn").trigger('click');
		$('#filter-mobile').removeClass('open');
		$('html').removeClass('filtersOpen');
		$(".disable-all").hide();
		$('body').css('overflow', 'auto');
		$(".filter-date-selection").removeClass('active').parents(".date-picker").removeClass("date-selected");
			$(".filter-container").removeClass("open");
		if ( typeof picker_desktop === 'object' ){
			picker_desktop.setDateRange(null,null);
		}
		ajaxReload();

	});

	var debounce = function (func, threshold, execAsap) {
			var timeout;

			return function debounced () {
					var obj = this, args = arguments;
					function delayed () {
							if (!execAsap)
									func.apply(obj, args);
							timeout = null;
					};

					if (timeout)
							clearTimeout(timeout);
					else if (execAsap)
							func.apply(obj, args);

					timeout = setTimeout(delayed, threshold || 100);
			};
	}

	jQuery('.fsFooterWrapper button:nth-child(2)').on('click', function(){
		window.scrollTo(0,0);
		$('#filter-mobile').removeClass('open');
		$('body').css('overflow', 'auto');
		$(".disable-all").hide();
		$('html').removeClass('filtersOpen');
		$(".filter-container").removeClass("open");
		tmFiltersApplyPending(); // "Apply": one reload for everything changed while the panel was open
	});

	const tmFilterInputsSelector = 'input:not(#act_price), select:not(#category-dropdown), select:not(.childrenGuests)';
	$('#main-content-area').on('change', tmFilterInputsSelector, function(event){
		if( tmFiltersPanelOpen() && $(event.currentTarget).parents(".activity-sort").length === 0 && $(event.currentTarget).parents(".product-card").length === 0 ){
			tmFiltersPendingReload = true; // mobile panel open: wait for Apply
		}
	});
	$('#main-content-area').on('change', tmFilterInputsSelector ,debounce(function(event){
		if( $(event.currentTarget).parents(".activity-sort").length === 0 && $(event.currentTarget).parents(".product-card").length === 0 ){
			if ( tmFiltersPendingReload || tmFiltersPanelOpen() ){
				return;
			}
			ajaxReload();
		}
	}, 150, false));

	// Initialize .clear-btn buttons
	var fSelectors = '.filter-option #popularFiltersHeading, .filter-option #ratngsFiltersHeading, .filter-option #durationsFiltersHeading, .filter-option #languagesFiltersHeading, .filter-option #ratngsFiltersHeading';
	$(fSelectors).parent().each(function(){
		if($(this).find('input:checked').length) {
			$(this).find('.clear-btn').show();
		}
	});

	showFiltersCount();
});


function updateFiltersCounts(data, $totalActivities) {
	var filtersMap = {
		'1dt3d': "checkbox1To3Days",
		'1t4': "checkbox1To4Hours",
		'3pd': "checkbox3PlusDays",
		'4ht1d': "checkbox4HoursTo1Day",
		'excellence_badge': "checkboxProductQualityExcellent",
		'hotel_pickup': "checkboxHotelPickup",
		'instant_confirmation': "checkboxInstantConfirmation",
		'kid_friendly': "checkboxKidFriendly",
		'free_cx': "checkboxFreeCx",
		'is_new': "checkboxIsNew",
		'likely_to_sell_out': "checkboxIsLikely",
		'safety_measures': "checkboxTakingSafetyMeasures",
		'morning': "checkboxMornig",
		'afternoon': "checkboxAfternoon",
		'evening': "checkboxEvening",
		'stars1': "one-stars-and-up",
		'stars2': "two-stars-and-up",
		'stars3': "three-stars-and-up",
		'stars4': "four-stars-and-up",
		'stars5': "five-stars",
		'u1h': "checkboxDurationUpTo1Hour",
		'private_tour': "checkboxIsPrivate",
		'skip_the_line': "checkboxHasSkipLine",
		'wheelchair_accesible': "checkboxWheelchair",
		'service_animals': "checkboxServiceAnimals",
		'stroller_accesible': "checkboxStrollerAccesible",
		'near_public_transport': "checkboxNearPublicTransport",
		'near_cruise_port': "checkboxNearCruisePort",
		'all_fitness_levels': "checkboxAllFitnessLevels",
		'free_parking': "checkboxFreeParking",
		'infants_free': "checkboxInfantsFree",
		'tm_top_tour': "checkboxTopTour",
		'suppressed_everywhere': "checkboxSuppressedEverywhere",
		'live': "checkboxLive",
	};
	for (var key in data) {
		if (data.hasOwnProperty(key)) {
			if( (data[key] == null) || (parseInt(data[key]) < 1) ) {
				$('#'+filtersMap[key]).prop('disabled', true);
				$('#'+filtersMap[key]).parent().parent().find('.f-count').text(0);
				$('[data-original="' + filtersMap[key] + '"]').prop('disabled', true);
				$('[data-original="' + filtersMap[key] + '"]').parent().parent().find('.f-count').text(0);
			}
			else {
				$('#'+filtersMap[key]).prop('disabled', false);
				$('#'+filtersMap[key]).parent().parent().find('.f-count').text(parseInt(data[key]));
				$('[data-original="' + filtersMap[key] + '"]').prop('disabled', false);
				$('[data-original="' + filtersMap[key] + '"]').parent().parent().find('.f-count').text(parseInt(data[key]));
			}
		}
	}

	if($totalActivities == 1) {
		jQuery('.activity-sort #totalActivitiesLabel').text('Result');
	}
	else {
		jQuery('.activity-sort #totalActivitiesLabel').text('Results');
	}
}

// scope: only the reviews inside it (the /stream/ page's cards as they load, so a review opened earlier stays open);
// none = every review on the page
function addReadMoreReviewContent( scope ){
	let $reviewsScope = scope ? $(scope) : $(document);
	if ( $reviewsScope.find(".review-body").length > 0 ){
		$reviewsScope.find(".review-body").each( function(){
			let reviewBodyInner = $(this).find(".review-body-inner");
			let reviewHeight = $(reviewBodyInner).prop("scrollHeight");
			let reviewLineHeight = parseInt( $(reviewBodyInner).css("line-height").replace("px","") );
			let totalLines = reviewHeight / reviewLineHeight;
			let reviewParent = $(this).parent();

			$reviewsScope.find(".read-more-review > span").text("Read full review");

			if ( totalLines > 3 ){
				$(this).addClass("closed");
				$(this).removeClass("opened");
				if ( $(this).find(".read-more-review").length === 0 ){
					$(reviewBodyInner).after('<a class="read-more-review" href="#"><span>Read full review</span><i class="far fa-chevron-down fa-xs"></i></a>') // no space before the icon: it was part of the link text
				}
			}else{
				$(this).removeClass("closed");
				$(this).addClass("opened");
				$(reviewParent).find(".read-more-review").remove();
			}


		})

		if ( typeof link_color != 'undefined' ){
			$reviewsScope.find("a.read-more-review").addClass(link_color);
		}
	}
}

// the ticket card's check-in codes (components/ticket-card.php): one at a time, swiped, the pill dots under them. Runs
// first in the ready handler (see there). jQuery is a global here, as everywhere in this file outside that handler.
function initTicketCodesSlickSlider(){
	var $ = jQuery;
	$(".c-ticket-card__codes--slider:not(.slick-initialized)").each(function(){
		var $strip = $(this);
		if ( typeof $.fn.slick !== "function" ) {
			$strip.removeClass("c-ticket-card__codes--slider"); // no slick: the styles' pre-init hide goes, every code shows
			return;
		}
		var moved = false; // set on the first move off code 1; from then on the pill marks the position, code 1 included

		// the current dot is dark and round from page load; it becomes the pill only once the visitor has moved off
		// code 1, and stays the pill for good (product-card-slider.js). Slick moves its own slick-active to the new dot as
		// a slide starts (slideHandler: beforeChange, then updateDots, then the animation, then afterChange), so is-current
		// moves on beforeChange with the slide it is going to, never 400 ms behind slick's dot; afterChange marks again,
		// because updateDots runs after any beforeChange handler and would leave slick-active on before the first move
		function markDots(index){
			moved = moved || index > 0;
			$strip.find(".slick-dots li").each(function(i){
				$(this).toggleClass("is-current", i === index);
				$(this).toggleClass("slick-active", moved && i === index);
			});
		}

		$strip.on("beforeChange", function(e, slick, currentSlide, nextSlide){
			markDots(nextSlide);
		});
		$strip.on("afterChange", function(e, slick, currentSlide){
			markDots(currentSlide);
		});
		$strip.on("reInit", function(e, slick){
			markDots(slick.currentSlide);
		});

		$strip.slick({
			arrows: false,
			dots: true,
			speed: 400,
			touchThreshold: 15,
			lazyLoad: "none",
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			infinite: false, // no cloned codes: the strip stops at the last guest
			rows: 0 // no wrapper divs (slick 1.8.1 adds them at rows:1)
		});
		markDots(0);
	});
}

function initBrandItemsSlickSlider(){

	$(".branding-items:not(.branding-items-no-slider)").slick({
			arrows: false,
			dots: true,
			speed: 400,
			touchThreshold: 15,
			lazyLoad: "none",
			slidesToShow: 1,
			adaptiveHeight: true,
			slidesToScroll: 1,
	});

}

function destroyBrandItemsSlickSlider(){
	$(".branding-items:not(.branding-items-no-slider)").slick('unslick');
}

function mobileGridSlickSlider( slider ){
		$(slider).slick({
					dots: false,
					infinite: true,
					speed: 300,
					rows: 1,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					touchThreshold: 20,
					responsive: [
							{
									breakpoint: 950,
									settings: {
											slidesToShow: 3,
											slidesToScroll: 3,
									}
							},
							{
									breakpoint: 600,
									settings: {
											slidesToShow: 2,
											slidesToScroll: 2,
									}
							},
							{
									breakpoint: 505,
									settings: {
											slidesToShow: 99,
											slidesToScroll: 99,
									}
							},
					]
		});


	$(slider).on("init.slick", function(){
		$(".scroll-slider.rows-2 .static-item").off().on("click",linkClick);
		//  var heights = $(".category-slider .product-card").map(function() {
		//   return $(this).height();
		// }).get()
	})

	$(slider).on("swipe", function(){
		$(".scroll-slider.rows-2 .static-item").off("click",linkClick);
	})

	$(slider).on("afterChange", function(){
		$(".scroll-slider.rows-2 .static-item").off().on("click",linkClick);
	})

}

function fixSlickSliderHeightGroupRows(){

	$(".same_group_size").each( function(){

		 var heights = $(this).find(".product-card").map(function() {
		  return $(this).height();
		}).get();

		var maxHeight = Math.ceil( Math.max.apply(null,heights) );
		$(this).find(".product-card").attr("style"," height: " + (maxHeight + 8) +"px !important")
		$(this).removeClass(".same_group_size");
	})
}

function fixSlickSliderHeight2Rows( slider ){
	 var heights = $(slider).find(".product-card").map(function() {
	  return $(this).height();
	}).get();

	var maxHeight = Math.ceil( Math.max.apply(null,heights) );
	$(slider).find(".product-card").attr("style"," height: " + (maxHeight + 8) +"px !important")
}

function desktopGridSlickSlider( slider ){

		$(slider).slick({
					dots: false,
					infinite: true,
					speed: 300,
					rows: 2,
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: false,
					touchThreshold: 20,
					responsive: [
							{
									breakpoint: 950,
									settings: {
											slidesToShow: 3,
											slidesToScroll: 3,
									}
							},
							{
									breakpoint: 600,
									settings: {
											slidesToShow: 2,
											slidesToScroll: 2,
									}
							},
							{
									breakpoint: 505,
									settings: {
											slidesToShow: 99,
											slidesToScroll: 99,
									}
							},
					]
		});


	$(slider).on("init.slick", function(){
		$(".scroll-slider.rows-2 .static-item").off().on("click",linkClick);
	})

	$(slider).on("swipe", function(){
		$(".scroll-slider.rows-2 .static-item").off("click",linkClick);
	})

	$(slider).on("afterChange", function(){
		$(".scroll-slider.rows-2 .static-item").off().on("click",linkClick);
	})

}

// where the finger went down: a touch that moved more than 10px was a scroll or swipe, not a tap
var toolTipTouchStart = null;

function toolTipTouchMoved(event){
	var touch = event.originalEvent && event.originalEvent.changedTouches ? event.originalEvent.changedTouches[0] : null;
	if ( !toolTipTouchStart || !touch ){
		return false;
	}
	return Math.abs(touch.clientX - toolTipTouchStart.x) > 10 || Math.abs(touch.clientY - toolTipTouchStart.y) > 10;
}

function toggleToolTip(event){
	event.stopPropagation();
	if ( is_touch_enabled() && !toolTipTouchMoved(event) ){
		$(".tooltip-cont, .c-tooltip-content").not( $(this).find(".tooltip-cont, .c-tooltip-content") ).hide();
		$(this).find(".tooltip-cont, .c-tooltip-content").toggle();
		// a js-placed tooltip is placed again now it is open: its real height, and the sheet it may sit in (COOL 587)
		if ( $(this).hasClass("c-tooltip-wrapper--js") && window.tmUtils ){
			tmUtils.cToolTipJsFix();
		}
	}
	return false;
}

function is_touch_enabled() {
	return ( 'ontouchstart' in window ) ||
			 ( navigator.maxTouchPoints > 0 ) ||
			 ( navigator.msMaxTouchPoints > 0 );
}

function makeAdditionalInfoSeeMoreClickable(){
	if ( $(".see-more-hidden-points.js-modal").length ){
		$(".see-more-hidden-points.js-modal").on("click", function(e){
		  	var modal_id = $(this).attr('href');
		  	$(".modal-bg").removeClass("modal-show");
		  	$(modal_id).addClass("modal-show");
		  	e.preventDefault();
			e.stopPropagation();
			$("body").css("overflow","hidden");

			const additionalInfoPoints = $(this).parents("#collapse-additional").find('.listWrapper').clone();
			$("#additional-info-more-points .modal-content").html( additionalInfoPoints );
			$("#additional-info-more-points .modal-content").find(".listWrapper .hidden").removeClass("hidden");
		});
	}
}

// $scope: a carousel whose slides just arrived (loadReviewCarousels()); the whole page when left out
function makeReviewsMoreLinkClickable( $scope ){
	const $moreLinks = $scope ? $scope.find(".review-more-link.js-modal") : $(".review-more-link.js-modal");
	if ( $moreLinks.length ){
		( $scope ? $scope.find(".product-card") : $(".c-recent-reviews .product-card") ).on("click", function(e){
			if ( isReviewSliding || e.target.tagName === "A" ){
				return;
			}

			$(this).find(".review-more-link").click();

		})
		$moreLinks.on("click", function(e){
		  	var modal_id = $(this).attr('href');
		  	e.preventDefault();
			e.stopPropagation();
			const reviewData = $(this).parents('.tile');
			showReviewModal({
				stars: $(reviewData).find(".stars").html(),
				title: $(reviewData).find(".title").html(),
				meta: $(reviewData).find(".user-published-at").html(),
				productTitle: $(reviewData).find(".product-name").html(),
				body: $(reviewData).find(".review-text").html(),
				productUrl: $(reviewData).find(".product-name").data("product-url"),
				productImage: $(reviewData).find("img").attr("src"),
			}, { modalId: modal_id });
		});
	}
}

// The review modal (elements/review-modal.php) on one review: the Reviews carousel's cards (above) and the /stream/
// page's Verified Reviews cards (photo-stream.js). review: the parts as HTML in the carousel card's shapes (stars, title,
// meta, productTitle, body) and productUrl, productImage. options.modalId: the modal (#review-modal, components/modal:
// the review goes in its body and the modal opens as every other one does, modal.js)
function showReviewModal( review, options ){
	options = options || {};
	const modal_id = options.modalId || '#review-modal';
	const reviewStars = review.stars;
	const reviewTitle = review.title;
	const reviewMeta = review.meta;
	const reviewProductTitle = review.productTitle;
	const reviewFullBody = review.body;
	const reviewProductUrl = review.productUrl;
	const reviewProductImage = review.productImage;
	const modal = typeof Modal !== 'undefined' ? ( Modal.instance(modal_id) || Modal.add(modal_id) ) : null;

	if ( !modal ){
		return;
	}

	$(modal_id + " .c-modal-body-inner-wrapper").html(`
				<div class="tile-top">
					<img src="${reviewProductImage}" alt="${reviewTitle}" width="64" height="64" />
					<div>
						<div class="product-name-placeholder product-name">${reviewProductTitle}</div>
						<div class="ratingRow desktop-only-must">
							<div>
								<div class="stars-placeholder">${reviewStars}</div>
							</div>
							<div class="reviewMeta">
								<div class="user-published-at-placeholder user-published-at mb-2">${reviewMeta}</div>							
							</div>
						</div>
					</div>
				</div>
				<div class="mobile-only">
					<div class="stars-placeholder">${reviewStars}</div>
					<div class="user-published-at-placeholder user-published-at mb-2">${reviewMeta}</div>
				</div>				
				<div class="title-placeholder title font-weight-semi-bold text-dark">${reviewTitle}</div>
				<div class="review-text-placeholder">${reviewFullBody}</div>
				<div class="review-product-link"><a class="c-btn c-btn-medium c-btn-rounded custom-primary" target="_blank" href="${reviewProductUrl}"><span>Check Availability</span></a></div>

			`);
	$(modal_id + " .c-modal-content, " + modal_id + " .c-modal-body").scrollTop(0); // each review opens at its top
	modal.open();
}

  function checkDeviceSize() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (width <= 700) {
      document.body.classList.remove("desktop");
      document.body.classList.add("mobile");
    } else {
      document.body.classList.remove("mobile");
      document.body.classList.add("desktop");
    }
  }

  window.addEventListener("load", checkDeviceSize);
  window.addEventListener("resize", checkDeviceSize);

if ( isMobileDevice ) {
	menuItems.forEach(item => {
	  item.addEventListener('click', function(event) {
	    event.preventDefault();
	    this.parentNode.classList.toggle("active");
	  });
	});
}

function getTextWidth(text) {
  var span = document.createElement("span");
  span.style.visibility = "hidden";
  span.style.whiteSpace = "nowrap";
  span.innerHTML = text;
  document.body.appendChild(span);
  var width = span.offsetWidth + 3;
  document.body.removeChild(span);
  return width;
}

function fixDatePickerStyling(){
	let select = document.getElementsByClassName("lightpick__select-months");

	let visibleSelect = Array.from(select).filter(function(element) {
		let ancestor = element.closest(".is-hidden");
		return ancestor === null;
	});

	for (const selectElement of visibleSelect) {
		let selectedText = selectElement.options[selectElement.selectedIndex].text;
		let selectedWidth = getTextWidth(selectedText);
		selectElement.style.width = selectedWidth + "px";
	}
}

function attachNewArrowsEvents( picker ){

	const event = isMobileDevice ? "touchstart" : "mouseup";
	$(document).on(event, ".lightpick__toolbar button i", function(){

		if ( $(this).parent().hasClass("lightpick__previous-action") ){
			picker.prevMonth();
		}else{
		 	picker.nextMonth();
		}
		fixDatePickerStyling( picker );
	});

}

// The review photo rows (elements/review.php's .review-body-media) as slick sliders, the arrows only when they overflow:
// the product page's reviews list (fetchReviews) and the /stream/ page's review cards (photo-stream.js)
function initReviewMediaSliders( reviewsElement ){
	function updateArrows( $slider ) {
		let vp      = $slider.find('.slick-list')[0];
		if ( !vp ) return;

		let total = 0;
		$slider.find('.slick-slide').not('.slick-cloned').each(function(){
			total += $(this).outerWidth(true);
		});

		if ( total === 0 ) {
			$slider.children(':not(.slick-arrow)').each(function(){
				total += $(this).outerWidth(true);
			});
		}

		if ( total > vp.clientWidth + 1 ) {
			$slider.addClass('media-overflow-yes');
		} else {
			$slider.removeClass('media-overflow-yes');
		}
	}

	$(reviewsElement).find(".review-body-media").each(function(){
		let $s = $(this);

		$s.slick({
			arrows: true,
			slidesToScroll: 3,
			slidesToShow: 2,
			variableWidth: true,
			speed: 400,
			infinite: false,
			touchThreshold: 20,
			prevArrow: '<button type="button" class="slick-prev c-btn c-btn-circle c-btn-shadow" aria-label="Previous"><i aria-hidden="true" class="fa-regular fa-chevron-left"></i></button>',
			nextArrow: '<button type="button" class="slick-next c-btn c-btn-circle c-btn-shadow" aria-label="Next"><i aria-hidden="true" class="fa-regular fa-chevron-right"></i></button>',
			responsive: [
				{
					breakpoint: 701,
					settings: {
						slidesToScroll: 1,
					}
				}
			]
		});

		updateArrows($s);

		$s.on('setPosition.slick breakpoint.slick reInit.slick afterChange.slick',
			() => updateArrows($s));

	});
}

function fetchReviews( selected_page, rating = 0 , needAnimation = true, animateScroll = true, reviewsElement  = '#reviews' ){

	// Placeholder rows while the reviews load (template rendered next to #reviews)
	if ( $('#tm-reviews-skeleton').length ){
		$(reviewsElement).html( $('#tm-reviews-skeleton').html() );
	}
	if ( needAnimation ){
		// Pagination (Prev/Next and page numbers) jumps instantly - animating there reads as
		// a delayed correction since the visitor just clicked something at the bottom of the
		// list. Rating-filter/clear-filter clicks (and everything else) keep the smooth scroll.
		if ( animateScroll ){
			$('html, body').animate({
					scrollTop: $(reviewsElement).offset().top - 88
			}, 1000);
		} else {
			$('html, body').scrollTop($(reviewsElement).offset().top - 88);
		}
	}

	// a GET with the action in the URL, which robots.txt blocks: the page's source holds no review (get_review_element_ajax())
	$.ajax({
		url: tmUtils.reviewsUrl('review_element_ajax', {
				'id': $(reviewsElement).data("id"),
				'paged': selected_page,
				'per_page':  $(reviewsElement).data("per-page"),
				'rating': rating,
		}),
		type: 'GET',
	})
	.done(function( response ) {
		$(reviewsElement).empty().append( response );

		initReviewMediaSliders( reviewsElement );
	})
	.fail(function() {
		$(reviewsElement).empty().append( "There is some technical issue. Please refresh the page." );
	});
}

// The product page's traveller photos (single-activity-content.php #traveler-photos-wrapper): the Traveler Photos
// block's thumbnails and the photo gallery's data (mediaGallery.travellerImages) come by AJAX (tm_reviews_photos),
// never in the page's source. The block and the gallery's "Your photos (N)" tab show once they arrive; the block goes
// when the product has none. Returns the request's promise (resolved either way), which a traveller-photo click waits
// for (activity-gallery.js); null off product pages.
var tmProductReviewPhotos = null;
function loadProductReviewPhotos(){
	const wrapper = $('[data-tm-reviews-photos]');
	if ( !wrapper.length ){
		return null;
	}
	if ( tmProductReviewPhotos === null ){
		tmProductReviewPhotos = $.ajax({
			url: tmUtils.reviewsUrl('tm_reviews_photos', { 'id': wrapper.data('tm-reviews-photos') }),
			type: 'GET',
			dataType: 'json',
		}).then(function( response ){
			const items = response && Array.isArray(response.items) ? response.items : [];
			if ( !items.length ){
				wrapper.remove();
				return;
			}
			mediaGallery.travellerImages = items;
			if ( typeof tmTravellerPhotos !== 'undefined' ){
				tmTravellerPhotos = items; // a gallery opened before they arrived builds its traveller tab from this
			}
			$('#collapse-traveler-photos').html( response.html || '' );
			wrapper.removeClass('c-hidden');
			$('#photos-gallery-product .tab-title.traveler-photos').text(function( i, text ){
				return text.replace(/\(\d+\)/, '(' + items.length + ')');
			}).removeClass('c-hidden');
		}, function(){
			wrapper.remove();
		});
	}
	return tmProductReviewPhotos;
}

// The review carousels (components/master-reviews): their slides come by AJAX (tm_reviews_carousel), never in the
// page's source. Each one's container shows once its slides arrive, and goes when there are none. context: where to
// look (the homepage's personalised blocks pass the HTML they insert); the whole page when left out.
function loadReviewCarousels( context ){
	$( context || document ).find('[data-tm-reviews-carousel]').each(function(){
		const $wrapper = $(this);
		let $container = $wrapper.closest('.recentReviews-container');
		if ( !$container.length ){
			$container = $wrapper.closest('.recentReviews');
		}
		const query = $wrapper.data('tm-reviews-carousel') || {};
		$wrapper.removeAttr('data-tm-reviews-carousel'); // asked once
		$.ajax({
			url: tmUtils.reviewsUrl('tm_reviews_carousel', query),
			type: 'GET',
			dataType: 'json',
		}).done(function( response ){
			if ( !response || !response.html ){
				$container.remove();
				return;
			}
			$wrapper.html( response.html );
			if ( typeof link_color !== 'undefined' ){
				$wrapper.find('.review-more-link').addClass( link_color );
			}
			$container.removeClass('c-hidden'); // before slick measures it
			loadSliders();
			makeReviewsMoreLinkClickable( $wrapper );
		}).fail(function(){
			$container.remove();
		});
	});
}

// The product page's featured review (?next): by AJAX (tm_reviews_featured) in its placeholder's place
function loadProductFeaturedReview(){
	const placeholder = $('[data-tm-reviews-featured]');
	if ( !placeholder.length ){
		return;
	}
	$.ajax({
		url: tmUtils.reviewsUrl('tm_reviews_featured', { 'id': placeholder.data('tm-reviews-featured') }),
		type: 'GET',
		dataType: 'json',
	}).done(function( response ){
		if ( response && response.html ){
			placeholder.replaceWith( response.html );
		} else {
			placeholder.remove();
		}
	}).fail(function(){
		placeholder.remove();
	});
}

function isElementInViewport(el) {
    // Check if the element is null or undefined
    if (!el) {
        return false;
    }

    // Get the bounding rectangle of the element
    const rect = el.getBoundingClientRect();

    // Check if the element is outside the viewport
    if (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
        return true;
    } else {
        return false;
    }
}


jQuery(function($){
	let pricingComponentData = null;
	let pricingComponentContainer = $('#pricing-component-js-container');

	if(pricingComponentContainer.length) {
		let activityId = pricingComponentContainer.data('id');
		let postId = pricingComponentContainer.data('post');
		let showTimes = (pricingComponentContainer.data('showTimes') === 0) ? 0 : 1;
		let showOptions = (pricingComponentContainer.data('showOptions') === 0) ? 0 : 1;
		let initialHidden = (pricingComponentContainer.data('initialHidden') === 1) ? 1 : 0;
		let showTopHeader = (pricingComponentContainer.data('showHeader') === 1) ? 1 : 0;
		let selectedOption = pricingComponentContainer.data('selectedOption') || '';

		let startDate = tmVisitorStore.getSavedStartDate();

		if(activityId) {
			$.ajax({
				url: ajaxurl,
				type: 'POST',
				data: {
						'action': 'get_pricing_component',
						'activityId': activityId,
						'postId': postId,
						'showTimes': showTimes,
						'showOptions': showOptions,
						'initialHidden': initialHidden,
						'startDate': startDate,
						'showTopHeader': showTopHeader,
						'selectedOption': selectedOption,
				},
			}).done(function(response) {
				//console.log(response);

				if(response.content) {
					pricingComponentData = response.data;
					//console.log(response.content);
					pricingComponentContainer.replaceWith(response.content);

					//initStickyHeaders();
				}
			});
		}
	}

	$(document).on('tmWidgetBookingDateSelected', function (e, date) {
		let savedEndDate = tmVisitorStore.getSavedEndDate();

		if(savedEndDate) {
			if(savedEndDate > date) {
				tmVisitorStore.saveSelectedDates(date, savedEndDate);
			}
			else {
				tmVisitorStore.saveSelectedDates(date, date);
			}
		}
		else {
			tmVisitorStore.saveSelectedDates(date, date);
		}
	});

	$(document).on('priceComponent', function(event) {
		if(!pricingComponentData) {
			return;
		}

		let componentRoot = event.componentRoot;
		let selectedOption = event.selectedOption;
		let selectedTime = event.selectedTime;
		let prices = null;
		let pricesHtml = '';

		/*console.log({
			componentRoot: componentRoot,
			selectedOption: selectedOption,
			selectedTime: selectedTime,
		});*/

		let priceOption = null;
		let timeKey = '';

		if(typeof selectedOption == 'undefined') {
			priceOption = pricingComponentData['data'][Object.keys(pricingComponentData['data'])[0]];
		}
		else {
			priceOption = pricingComponentData['data'][selectedOption] || null;
		}

		if(priceOption) {
			if(typeof selectedTime == 'undefined') {
				timeKey = Object.keys(priceOption['times'])[0];
			}
			else {
				timeKey = selectedTime;
			}
		}

		if(priceOption && timeKey) {
			prices = priceOption['times'][timeKey];
		}

		if(prices) {
			for (const [key, value] of Object.entries(prices['prices'])) {
				let ageBandPrice = value.tmRetail;

				if(ageBandPrice == '0' || ageBandPrice == 0) {
					ageBandPrice = 'Free';
				}
				else {
					ageBandPrice = '$' + ageBandPrice;
				}

				let pricingBoxUnitPriceClass = value.isUnitPrice ? 'pricing__box____is_unit' : '';
				pricesHtml += `<div class="pricing__box ${pricingBoxUnitPriceClass}">
					<div class="pricing__box__inner">
						<div class="pricing__title">${key}</div>
						<div class="pricing__age">${value.ageRange}</div>
						<div class="pricing__tag">${ageBandPrice}</div>
					</div>
				</div>`;
			}

			componentRoot.find('.pricing__section').empty().html(pricesHtml);
			componentRoot.find('.pricing__section').removeClass('c-hidden');
			componentRoot.find('.pricing__footer').removeClass('c-hidden');
		}
		else {
			componentRoot.find('.pricing__section').addClass('c-hidden');
			componentRoot.find('.pricing__footer').addClass('c-hidden');
		}

		/*console.log({
			priceOption: priceOption,
			timeKey: timeKey,
			prices: prices,
		});*/
	});

	// Handle change events in pricing components.

	$(document).on('change', '.c-product-pricing .c-select-control select', function(event) {
		let componentRoot = $(event.target).closest('.c-product-pricing');
		let timesSelect = componentRoot.find('[name=product-pricing-select-times]');
		let optionsSelect = componentRoot.find('[name=product-pricing-select-options]');
		let target = $(event.target);
		let prices = null;
		let pricesHtml = '';

		let selectedOption;
		let selectedTime;
		/*
		 * Change handler for product options
		 */
		if(target.prop('name') == 'product-pricing-select-options') {

			selectedOption = optionsSelect.val();

			if(timesSelect.length) {
				let newSelectOptions = Object.keys(pricingComponentData['data'][optionsSelect.val()]['times']);

				timesSelect.find('option').remove();

				timesSelect.append($("<option/>", {value: 'select-option', text: 'Select option', disabled: true}));

				$.each(newSelectOptions, function(key, value) {
					let option = $("<option/>", {value: key, text: value});
					timesSelect.append(option);
				});
			}
		}

		if(target.prop('name') == 'product-pricing-select-times') {
			if(optionsSelect.length) {
				selectedOption = optionsSelect.val();
				selectedTime = target.find(':selected').text().trim();
			}
			else {
				selectedTime = target.find(':selected').text().trim();
			}
		}

		$(document).trigger({
			type: 'priceComponent',
			componentRoot: componentRoot,
			selectedOption: selectedOption,
			selectedTime: selectedTime
		});
	});
});
